import {reviewedFallbackTranslations} from './reviewedFallbackTranslations';
import { applicationTranslations } from './applicationTranslations';
import { workspaceTranslations } from './workspaceTranslations';
export const translations = {
  es: {
    common: {
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      add: 'Agregar',
      search: 'Buscar',
      loading: 'Cargando...',
      noData: 'Sin datos',
      confirm: 'Confirmar',
      back: 'Volver',
      today: 'Hoy',
      total: 'Total',
      actions: 'Acciones',
      new: 'Nuevo',
      close: 'Cerrar',
      yes: 'Si',
      no: 'No',
      all: 'Todos',
      none: 'Ninguno',
      select: 'Seleccionar',
      download: 'Descargar',
      upload: 'Subir',
      send: 'Enviar',
      share: 'Compartir',
      view: 'Ver',
      manage: 'Gestionar',
      filter: 'Filtrar',
      sort: 'Ordenar',
      export: 'Exportar',
      import: 'Importar',
      print: 'Imprimir',
      copy: 'Copiar',
      paste: 'Pegar',
      refresh: 'Actualizar',
      details: 'Detalles',
      status: 'Estado',
      active: 'Activo',
      inactive: 'Inactivo',
      pending: 'Pendiente',
      completed: 'Completado',
      date: 'Fecha',
      time: 'Hora',
      name: 'Nombre',
      email: 'Correo',
      phone: 'Telefono',
      address: 'Direccion',
      notes: 'Notas',
      description: 'Descripcion',
      amount: 'Monto',
      price: 'Precio',
      quantity: 'Cantidad',
      category: 'Categoria',
      type: 'Tipo',
      from: 'Desde',
      to: 'Hasta',
      of: 'de',
      or: 'o',
      and: 'y',
      howToUse: '¿Cómo usar?',
      myBusiness: 'Mi Negocio',
      noData: 'Sin datos',
      noResults: 'Sin resultados',
      noResultsDesc: 'No hay datos para mostrar',
      addFirst: 'Agregar primero',
      tryAgain: 'Intentar de nuevo',
      next: 'Siguiente',
      previous: 'Anterior',
      finish: 'Finalizar',
      apply: 'Aplicar',
      reset: 'Reiniciar',
      copy: 'Copiar',
      duplicate: 'Duplicar',
      preview: 'Vista Previa',
      generate: 'Generar',
      success: '¡Éxito!',
      error: 'Error',
      warning: 'Advertencia',
      info: 'Información',
      required: 'Requerido',
      optional: 'Opcional',
      selectOption: 'Selecciona una opción',
    },
    banners: {
      appointments: { title: 'Sistema de Citas', subtitle: 'Gestiona tus citas con clientes', noAppointments: 'No hay citas', },
      arqueo: { title: 'Arqueo de Caja', subtitle: 'Verifica el efectivo físico en caja', help: 'Cuenta el dinero físico en tu caja para verificar que coincida con las ventas e ingresos del sistema. Puedes hacer arqueos varias veces al día.' },
      
      bills: { title: 'Control de Pagos', subtitle: 'Evita intereses, paga a tiempo', help: 'Registra tus cuentas por pagar y controla deudores.' },
      
      budget: { title: 'Presupuestos & Estimados', subtitle: 'Gestiona tus finanzas y cotizaciones', help: 'Crea presupuestos para controlar gastos y estimados profesionales para tus clientes.' },
      
      businesscard: { title: 'Tarjeta de Presentación', subtitle: 'Diseña y comparte tu tarjeta profesional' },
      cajaregistradora: { title: 'Mi Contador', subtitle: 'Tu oficina virtual de finanzas' },
      cashflow: { title: 'Flujo de Caja', subtitle: 'Visualiza tus entradas y salidas de dinero', help: 'Aquí puedes ver el movimiento de dinero de tu negocio: ingresos por ventas, otros ingresos y gastos. El balance te indica si estás en positivo o negativo.' },
      
      cash: { title: 'Caja del Día', subtitle: 'Control de ingresos y gastos diarios', help: 'Registra tus ingresos y gastos diarios. Las ventas del POS se suman automáticamente.' },
      
      chat: { title: 'Comunicación', subtitle: 'Chat interno y videollamadas' },
      closing: { title: 'Cierre de Caja', subtitle: 'Estado de resultados y cierre diario' },
      companies: { title: 'Mis Empresas', subtitle: 'Gestiona múltiples corporaciones desde un perfil', noCompanies: 'No hay empresas registradas', },
      comparative: { title: 'Comparativo de Períodos', subtitle: 'Compara el rendimiento entre períodos', help: 'Compara tus ingresos, gastos y balance entre el período actual y el anterior. Esto te ayuda a identificar tendencias y patrones en tu negocio.' },
      
      customers: { title: 'Clientes y Prospectos', subtitle: 'CRM para gestionar clientes y oportunidades', help: 'Administra tu base de clientes, agrupa por categorías, rastrea prospectos de venta y ve el historial de compras.' },
      
      expenseanalysis: { title: 'Análisis de Gastos', subtitle: 'Entiende a dónde va tu dinero' },
      facturas: { title: 'Archivador de Facturas', subtitle: 'Guarda y organiza tus facturas' },
      financialreports: { title: 'Reportes Financieros', subtitle: 'Análisis de la situación económica del negocio', help: 'Analiza el rendimiento de tu negocio. Ve reportes de ingresos, gastos, flujo de caja y gráficos comparativos por período.' },
      
      financialtools: { title: 'Herramientas Financieras', subtitle: 'Analiza y optimiza tus finanzas' },
      news: { title: 'Noticias en Vivo', subtitle: 'Mantente al día con el mundo de los negocios' },
      pos: { title: 'Caja Registradora', subtitle: 'Busca productos, agrega al carrito y completa la venta', help: "Busca productos, agrégalos al carrito, aplica descuentos y completa la venta. Registra ingresos en efectivo (manual) o al final del día usa 'Cerrar Caja' para registrar el cierre." },
      
      payroll: { title: 'Nómina', subtitle: 'Gestiona empleados y pagos', help: 'Registra empleados, genera nóminas periódicas, controla asistencia y calcula pagos automáticamente.' },
      
      pricing: { title: 'Planes y Precios', subtitle: 'Elige el plan perfecto para tu negocio' },
      profitability: { title: 'Análisis de Rentabilidad', subtitle: 'Analiza las ganancias por producto', help: 'Conoce cuáles productos te generan más ganancia. El margen de ganancia se calcula como (Ganancia / Ingreso) x 100.' },
      
      projections: { title: 'Proyecciones Financieras', subtitle: 'Visualiza el futuro de tu negocio', help: 'Las proyecciones se calculan basándose en tu historial de ventas de los últimos 6 meses.' },
      
      purchases: { title: 'Compras y Proveedores', subtitle: 'Gestiona tus ordenes de compra', help: 'Registra proveedores, crea órdenes de compra y haz seguimiento de entregas.', helpLong: 'Registra proveedores, crea órdenes de compra y haz seguimiento de entregas. El inventario se actualiza automáticamente.' },
      
      salesgoals: { title: 'Metas de Ventas', subtitle: 'Establece y monitorea tus objetivos' },
      tasks: { title: 'Control de Tareas', subtitle: 'Organiza tu día, ahorra tiempo', help: 'Crea tareas con fecha y hora, establece recordatorios, y organiza por categorías.' },
      
      toolrelationships: { title: 'Mapa de Relaciones', subtitle: 'Cómo se conectan las herramientas entre sí' },
      transport: { title: 'Transporte / Flota', subtitle: 'Gestión de vehículos y gastos' },
      contacts: { title: 'Mis Contactos', subtitle: 'Gestiona contactos y clientes' },
      saleshistory: { title: 'Historial de Ventas', subtitle: 'Revisa tus ventas pasadas' },
      admin: { title: 'Administración', subtitle: 'Panel de control administrativo' },
      install: { title: 'Instalar App', subtitle: 'Instala BRIEFCASE en tu dispositivo' },
      
      caja: { title: 'Mi Contador', help: 'Tu contador virtual personal. Registra ingresos, gastos, servicios y ventas. Haz cierre de caja diario y ve el estado de resultados en tiempo real.' },
      
      
      dashboard: { title: 'Inicio', help: 'Resumen de tu negocio: Ventas (plata), Ingresos (dorado), Gastos (naranja) y Ganancia (verde). Abajo verás el gráfico de ventas de la semana.' },
      expenseAnalysis: { title: 'Análisis de Gastos', help: 'Visualiza cómo se distribuyen tus gastos por categoría. Identifica las áreas donde más gastas para tomar mejores decisiones financieras.' },
      financialTools: { title: 'Herramientas Financieras', help: 'Aquí puedes ver tu flujo de caja, establecer metas de ventas, comparar períodos, analizar rentabilidad por producto y exportar reportes.' },
      
      
      
      salesGoals: { title: 'Metas de Ventas', help: 'Crea metas semanales, mensuales o anuales para tu negocio. El sistema calculará automáticamente tu progreso basado en las ventas realizadas.' },
      salesHistory: { title: 'Historial de Ventas', help: 'Consulta todas las ventas realizadas. Filtra por fecha, ve detalles de cada transacción y envía recibos por WhatsApp.' },
      
      
      
      
      inventory: { title: 'Inventario', help: 'Administra tus productos y servicios. Agrega nuevos, edita existentes, usa el escáner de código de barras y genera etiquetas.' },
      
      
      
      
    },
    auth: {
      login: 'Iniciar Sesion',
      register: 'Registrarse',
      logout: 'Cerrar Sesion',
      email: 'Correo electronico',
      password: 'Contrasena',
      businessName: 'Nombre del negocio',
      welcomeBack: 'Bienvenido de nuevo',
      createAccount: 'Crear cuenta',
      noAccount: 'No tienes cuenta?',
      hasAccount: 'Ya tienes cuenta?',
      forgotPassword: 'Olvidaste tu contrasena?',
      resetPassword: 'Restablecer contrasena',
    },
    nav: {
      dashboard: 'Dashboard',
      posUnified: 'Caja / POS',
      groupCrm: 'CRM y Clientes',
      groupOps: 'Operación',
      groupMore: 'Más',
      groupAdmin: 'Administración',
      pos: 'Punto de Venta',
      posGroup: 'Punto de Venta',
      myAccountant: 'Mi Contador',
      cashRegister: 'Caja Registradora',
      cashIncome: 'Ingresos en Efectivo',
      salesHistory: 'Historial Ventas',
      cashAudit: 'Arqueo de Caja',
      inventory: 'Inventario',
      cash: 'Caja del Dia',
      closing: 'Arqueo de Caja',
      settings: 'Configuracion',
      realEstate: 'Bienes Raices',
      clients: 'Clientes',
      contacts: 'Contactos',
      news: 'Noticias',
      finances: 'Finanzas',
      financesDashboard: 'Dashboard Financiero',
      cashFlow: 'Flujo de Caja',
      salesGoals: 'Metas de Ventas',
      expenseAnalysis: 'Analisis de Gastos',
      comparative: 'Comparativo',
      profitability: 'Rentabilidad',
      projections: 'Proyecciones',
      budget: 'Presupuestos',
      payroll: 'Nomina',
      invoices: 'Facturas',
      appointments: 'Citas',
      transport: 'Transporte',
      reports: 'Reportes',
      admin: 'Administracion',
      revenue: 'Ingresos (Admin)',
      chat: 'Comunicacion',
      bills: 'Pagos',
      tasks: 'Tareas',
      notes: 'Mis Notas',
      priceIndex: 'Indice de Precios',
      services: 'Servicios',
      purchases: 'Compras',
      companies: 'Empresas',
      toolMap: 'Mapa de Relaciones',
      businessCard: 'Tarjeta',
      pricing: 'Planes',
      installApp: 'Instalar App',
    },
    dashboard: {
      title: 'Dashboard',
      subtitle: 'Resumen de tu negocio',
      todaySales: 'Ventas de Hoy',
      controlCenter: 'Centro de Control',
      goodMorning: 'Buenos días',
      goodAfternoon: 'Buenas tardes',
      goodEvening: 'Buenas noches',
      briefySays: 'Briefy dice',
      todayAgenda: 'Agenda de Hoy',
      noEventsToday: 'Sin citas ni tareas para hoy. Agenda algo para empezar.',
      viewAll: 'Ver todo',
      chooseIndustry: 'Elige tu industria',
      industryHint: 'Adapta tu Centro de Control con imágenes y accesos de tu tipo de negocio.',
      industrySaved: 'Centro de Control personalizado',
      vsYesterday: 'vs ayer',
      salesUp: 'Tus ventas suben',
      salesDown: 'Tus ventas bajan',
      thisWeek: 'esta semana',
      briefyDefault: 'Hoy es un gran día para hacer crecer tu negocio.',
      apptLabel: 'Nueva Cita',
      tutorialBtn: 'Ver tutorial',
      weekTotal: 'Total semana',
      briefyRole: 'Asistente IA · En línea',
      talkToBriefy: 'Hablar con Briefy',
      summaryLine: 'Aqui esta el resumen de tu negocio.',
      period_today: 'Hoy',
      period_7d: '7 dias',
      period_30d: '30 dias',
      revenueOverview: 'Resumen de Ventas',
      incomeVsExpenses: 'Ingresos vs Gastos',
      recentTransactions: 'Transacciones Recientes',
      pendingInvoices: 'Facturas Pendientes',
      noTransactions: 'Sin transacciones todavia',
      noPendingInvoices: 'Sin facturas pendientes',
      vsPrev: 'vs periodo anterior',
      todayIncome: 'Ingresos de Hoy',
      todayExpenses: 'Gastos de Hoy',
      netProfit: 'Ganancia Neta',
      salesCount: 'Numero de Ventas',
      lowStock: 'Productos con Bajo Stock',
      weeklyStats: 'Estadisticas Semanales',
      sales: 'VENTAS',
      income: 'INGRESOS',
      expenses: 'GASTOS',
      profit: 'GANANCIA',
      salesLabel: 'ventas',
      saleSingular: 'venta',
      loadError: 'No se pudieron cargar algunos datos. Intenta de nuevo.',
      welcome: 'Bienvenido',
      quickActions: 'Acciones Rapidas',
      recentActivity: 'Actividad Reciente',
      monthlyOverview: 'Resumen Mensual',
      topProducts: 'Productos Mas Vendidos',
      pendingTasks: 'Tareas Pendientes',
    },
    realEstate: {
      title: 'Bienes Raices',
      subtitle: 'Gestiona propiedades y clientes',
      properties: 'Propiedades',
      clients: 'Clientes',
      coBrokers: 'Co-Brokers',
      tracking: 'Seguimiento',
      forSale: 'En Venta',
      forRent: 'En Alquiler',
      buyers: 'Compradores',
      tenants: 'Inquilinos',
      sellers: 'Vendedores',
      activeProspects: 'Activos',
      closed: 'Cerrados',
      documents: 'Documentos',
      addProperty: 'Agregar Propiedad',
      addClient: 'Agregar Cliente',
      addBroker: 'Agregar Co-Broker',
      propertyType: 'Tipo de Propiedad',
      bedrooms: 'Habitaciones',
      bathrooms: 'Banos',
      area: 'Area',
      location: 'Ubicacion',
      budget: 'Presupuesto',
      activeProspect: 'Prospecto Activo',
      incompleteDoc: 'Documentacion Incompleta',
      completeDoc: 'Documentacion Completa',
      programBeneficiary: 'Beneficiario de Programa',
      importFromExcel: 'Importar desde Excel',
      importFromPhone: 'Importar desde Celular',
      howToUse: 'Como usar?',
      interaction: 'Interaccion',
      addInteraction: 'Agregar Interaccion',
    },
    contacts: {
      title: 'Contactos',
      subtitle: 'Gestiona tu red de contactos',
      addContact: 'Agregar Contacto',
      allContacts: 'Todos los Contactos',
      favorites: 'Favoritos',
      recent: 'Recientes',
      company: 'Empresa',
      position: 'Cargo',
      tags: 'Etiquetas',
      searchPlaceholder: 'Buscar por nombre, telefono, email o empresa...',
    },
    finances: {
      title: 'Centro Financiero',
      subtitle: 'Gestiona tus finanzas',
      cashFlow: 'Flujo de Caja',
      bills: 'Cuentas por Pagar',
      receivables: 'Cuentas por Cobrar',
      budget: 'Presupuestos',
      reports: 'Reportes Financieros',
      income: 'Ingresos',
      expenses: 'Gastos',
      balance: 'Balance',
      profit: 'Ganancia',
      loss: 'Perdida',
      revenue: 'Facturacion',
      costs: 'Costos',
      operatingExpenses: 'Gastos Operativos',
      netIncome: 'Ingreso Neto',
      grossProfit: 'Ganancia Bruta',
    },
    documents: {
      title: 'Documentos',
      subtitle: 'Gestiona archivos y firmas',
      upload: 'Subir Documento',
      sign: 'Firmar',
      download: 'Descargar',
      signed: 'Firmado',
      unsigned: 'Sin Firmar',
      pending: 'Pendiente',
      sendForSignature: 'Enviar para Firma',
      eSign: 'Firma Electronica',
      downloadSigned: 'Descargar Firmado',
      signatureDate: 'Fecha de Firma',
      signedBy: 'Firmado por',
      placeSignature: 'Coloque su firma',
      drawSignature: 'Dibuje su Firma',
      clearSignature: 'Limpiar',
      saveSignature: 'Guardar',
      signatures: 'Firmas',
      tapToPlace: 'Toque donde desea la firma',
      dragToMove: 'Arrastre para mover',
      size: 'Tamano',
    },
    pos: {
      title: 'Punto de Venta',
      searchProduct: 'Buscar producto...',
      cart: 'Carrito',
      emptyCart: 'Carrito vacio',
      subtotal: 'Subtotal',
      discount: 'Descuento',
      tax: 'Impuesto',
      taxableBase: 'Base gravable',
      total: 'Total',
      completeSale: 'Completar Venta',
      paymentMethod: 'Metodo de pago',
      cash: 'Efectivo',
      card: 'Tarjeta',
      transfer: 'Transferencia',
      saleComplete: 'Venta completada',
      addToCart: 'Agregar al carrito',
      removeFromCart: 'Quitar del carrito',
      checkout: 'Pagar',
      receipt: 'Recibo',
    },
    briefySettings: {
      desc: 'Controla como Briefy te acompana dentro de BRIEFCASE.',
      interactive: 'Modo Interactivo de Briefy',
      interactiveDesc: 'Briefy aparece como un personaje vivo dentro de la app',
      idle: 'Interacciones en reposo',
      idleDesc: 'Briefy se asoma cuando llevas ~1 minuto sin actividad',
      haptics: 'Vibracion tactil',
      hapticsDesc: 'Vibracion suave al aparecer (solo movil)',
      sound: 'Efectos de sonido',
      soundDesc: 'Sonido sutil cuando Briefy aparece',
      animations: 'Animaciones de Briefy',
      animationsDesc: 'Animaciones de entrada, movimiento y gestos',
    },
    inventory: {
      title: 'Inventario',
      labelsBtn: 'Etiquetas',
      addProduct: 'Agregar Producto',
      editProduct: 'Editar Producto',
      productName: 'Nombre del producto',
      description: 'Descripcion',
      price: 'Precio de venta',
      cost: 'Costo',
      stock: 'Stock',
      category: 'Categoria',
      isService: 'Es un servicio',
      sku: 'SKU',
      products: 'Productos',
      services: 'Servicios',
      lowStock: 'Stock Bajo',
      outOfStock: 'Agotado',
      inStock: 'En Stock',
    },
    payroll: {
      title: 'Nomina',
      subtitle: 'Gestiona empleados y pagos',
      employees: 'Empleados',
      addEmployee: 'Agregar Empleado',
      salary: 'Salario',
      bonus: 'Bonificacion',
      deductions: 'Deducciones',
      netPay: 'Pago Neto',
      payPeriod: 'Periodo de Pago',
      generatePayroll: 'Generar Nomina',
      earnings: 'Ingresos',
      taxWithholding: 'Retencion de Impuestos', noRecords: 'No hay registros de nómina', noAttendance: 'No hay registros de asistencia este mes', noPaystubs: 'No hay pay stubs generados', },
    appointments: {
      title: 'Citas',
      subtitle: 'Gestiona tus citas con clientes',
      schedule: 'Programar Cita',
      upcoming: 'Proximas',
      past: 'Pasadas',
      cancelled: 'Canceladas',
      reschedule: 'Reprogramar',
      client: 'Cliente',
      dateTime: 'Fecha y Hora',
      location: 'Ubicacion',
      reminder: 'Recordatorio',
    },
    news: {
      title: 'Noticias',
      subtitle: 'Mantente informado',
      createPost: 'Crear Publicacion',
      feed: 'Feed',
      myPosts: 'Mis Publicaciones',
      like: 'Me gusta',
      comment: 'Comentar',
      share: 'Compartir',
      searchNews: 'Buscar noticias...',
    },
    settings: {
      title: 'Configuracion',
      currency: 'Moneda',
      language: 'Idioma',
      businessName: 'Nombre del Negocio',
      taxConfig: 'Configuración de Impuestos',
      applyTax: 'Aplicar impuesto a las ventas',
      selectRegion: 'Selecciona tu región',
      taxRatePct: 'Tasa de impuesto (%)',
      taxNameLabel: 'Nombre del impuesto',
      invoicePreview: 'Vista previa en factura:',
      accountInfo: 'Información de cuenta',
      plan: 'Plan',
      planBusiness: 'Empresarial',
      planFree: 'Gratuito',
      subSuccess: '¡Suscripción Exitosa!',
      subSuccessDesc: 'Tu plan ha sido actualizado. Disfruta de todas las funciones.',
      profile: 'Perfil',
      account: 'Cuenta',
      notifications: 'Notificaciones',
      security: 'Seguridad',
      theme: 'Tema',
      darkMode: 'Modo Oscuro',
      lightMode: 'Modo Claro',
      changePassword: 'Cambiar Contrasena',
      twoFactor: 'Autenticacion de Dos Factores',
    },
    errors: {
      required: 'Este campo es requerido',
      invalidEmail: 'Correo electronico invalido',
      invalidPhone: 'Telefono invalido',
      minLength: 'Minimo {0} caracteres',
      maxLength: 'Maximo {0} caracteres',
      networkError: 'Error de conexion',
      serverError: 'Error del servidor',
      notFound: 'No encontrado',
      unauthorized: 'No autorizado',
      forbidden: 'Acceso denegado',
      loadError: 'Error al cargar',
      saveError: 'Error al guardar',
      deleteError: 'Error al eliminar',
    },
    success: {
      saved: 'Guardado exitosamente',
      deleted: 'Eliminado exitosamente',
      updated: 'Actualizado exitosamente',
      created: 'Creado exitosamente',
      sent: 'Enviado exitosamente',
      copied: 'Copiado al portapapeles',
    },
    tutorial: {
      welcome: 'Bienvenido a BRIEFCASE',
      skip: 'Saltar',
      next: 'Siguiente',
      previous: 'Anterior',
      finish: 'Finalizar',
      step: 'Paso',
    },
    categories: {
      all: 'Todas las Categorias',
      manage: 'Gestionar Categorias',
    },
    ui: {
      description: 'Descripción',
      category: 'Categoría',
      phone: 'Teléfono',
      address: 'Dirección',
      location: 'Ubicación',
      period: 'Período',
      commission: 'Comisión',
      code: 'Código',
      client: 'Cliente',
      clientName: 'Nombre del cliente',
      vehicle: 'Vehículo',
      type: 'Tipo',
      newConversation: 'Nueva Conversación',
      online: 'En línea',
      noMessages: 'No hay mensajes',
      startConversation: 'Inicia la conversación',
      selectConversation: 'Selecciona una conversación',
      noUsersAvailable: 'No hay usuarios disponibles',
      searchUsers: 'Buscar usuarios...',
      noConversations: 'No hay conversaciones',
      noDocuments: 'No hay documentos',
      noVehiclesRegistered: 'No hay vehículos registrados',
      noExpensesRegistered: 'No hay gastos registrados',
      noPropertiesRegistered: 'No hay propiedades registradas',
      noClientsRegistered: 'No hay clientes registrados',
      noContactsRegistered: 'No hay contactos registrados',
      noInvoicesRegistered: 'No hay facturas registradas',
      noPaymentsRegistered: 'No hay pagos registrados',
      noTasksRegistered: 'No hay tareas registradas',
      noEmployeesRegistered: 'No hay empleados registrados',
      noBudgetsRegistered: 'No hay presupuestos registrados',
      noEstimatesRegistered: 'No hay estimados registrados',
      noPurchasesRegistered: 'No hay compras registradas',
      noAppointmentsRegistered: 'No hay citas registradas',
      noSalesRegistered: 'No hay ventas registradas',
      noProductsRegistered: 'No hay productos registrados',
      noResults: 'No hay resultados',
      noMovementsToday: 'No hay movimientos para este día',
      addFirstProperty: '+ Agregar primera propiedad',
      addFirstClient: '+ Agregar primer cliente',
      addFirstContact: '+ Agregar primer contacto',
      addFirstItem: '+ Agregar primero',
      whatsappNumber: 'Número de WhatsApp',
      avgRating: 'Calificación Promedio',
      yearTotal: 'Total Año',
      monthTotal: 'Total Mes',
      dayTotal: 'Total Día',
      bonus: 'Bonificación',
      medicalInsurance: 'Seguro Médico',
      employeeInfo: 'INFORMACIÓN DEL EMPLEADO',
      periodInfo: 'INFORMACIÓN DEL PERÍODO',
      validUntil: 'Válido hasta',
      validityDays: 'Días de validez',
      termsConditions: 'Términos y Condiciones',
      termsPlaceholder: 'Términos y condiciones...',
      addItem: 'Agregar ítem',
      newBudget: 'Nuevo Presupuesto',
      newEstimate: 'Nuevo Estimado',
      selectCategory: 'Selecciona una categoría',
      uncategorized: 'Sin categoría',
      allVehicles: 'Todos los vehículos',
      clientType: 'Tipo de Cliente',
      company: 'Compañía',
      active: 'Activo',
      inactive: 'Inactivo',
      pending: 'Pendiente',
      completed: 'Completado',
      cancelled: 'Cancelado',
      paid: 'Pagado',
      unpaid: 'No pagado',
      total: 'Total',
      subtotal: 'Subtotal',
      tax: 'Impuesto',
      discount: 'Descuento',
      quantity: 'Cantidad',
      price: 'Precio',
      stock: 'Stock',
      sku: 'SKU',
      barcode: 'Código de barras',
      profit: 'Ganancia',
      revenue: 'Ingreso',
      expense: 'Gasto',
      payment: 'Pago',
      method: 'Método',
      status: 'Estado',
      notes: 'Notas',
      addNotes: 'Agregar notas...',
      pickDate: 'Seleccionar fecha',
      pickTime: 'Seleccionar hora',
      uploadImage: 'Subir Imagen',
      changeImage: 'Cambiar Imagen',
      removeImage: 'Quitar Imagen',
      saving: 'Guardando...',
      deleting: 'Eliminando...',
      uploading: 'Subiendo...',
      processing: 'Procesando...',
      retry: 'Reintentar',
      tryAgain: 'Intentar de nuevo',
      seeAll: 'Ver todo',
      seeMore: 'Ver más',
      seeLess: 'Ver menos',
      thisWeek: 'Esta semana',
      thisMonth: 'Este mes',
      thisYear: 'Este año',
      lastWeek: 'Semana pasada',
      lastMonth: 'Mes pasado',
      lastYear: 'Año pasado',
      today: 'Hoy',
      yesterday: 'Ayer',
      tomorrow: 'Mañana',
      confirmDelete: '¿Eliminar?',
      confirmDeleteDesc: 'Esta acción no se puede deshacer',
      saved: 'Guardado',
      created: 'Creado',
      updated: 'Actualizado',
      deleted: 'Eliminado',
      errorOccurred: 'Ocurrió un error',
      tryLater: 'Intenta más tarde',
      requiredField: 'Campo requerido',
      invalidEmail: 'Email inválido',
      invalidPhone: 'Teléfono inválido',
      passwordTooShort: 'Contraseña muy corta',
      passwordsDontMatch: 'Las contraseñas no coinciden',
      // Payroll specific
      activeEmployees: 'Empleados Activos',
      generatePayroll: 'Generar Nómina',
      monthPayroll: 'Nómina del Mes',
      employees: 'Empleados',
      payrollPayments: 'Pagos de Nómina',
      payStubs: 'Recibos',
      attendance: 'Asistencia',
      noEmployees: 'No hay empleados',
      activos: 'Activos',
      inactivos: 'Inactivos',
      todos: 'Todos',
      // Real Estate
      todosCategoria: 'Todos',
    },
    settings: {
      title: 'Configuración',
      subtitle: 'Personaliza tu cuenta y preferencias',
      profilePhoto: 'Foto de Perfil',
      changePhoto: 'Cambiar Foto',
      photoFormats: 'JPG, PNG, WEBP o GIF. Máximo 5MB.',
      businessInfo: 'Información del Negocio',
      contactInfo: 'Información de Contacto',
      businessAddress: 'Dirección del Negocio',
      businessPhone: 'Teléfono del Negocio',
      businessEmail: 'Email del Negocio',
      businessFax: 'Fax del Negocio',
      currency: 'Moneda',
      language: 'Idioma',
      tax: 'Impuesto',
      taxName: 'Nombre del Impuesto',
      taxRate: 'Tasa del Impuesto',
      taxEnabled: 'Impuesto Activo',
      twoFactor: 'Autenticación de Dos Factores',
      changePassword: 'Cambiar Contraseña',
      businessName: 'Nombre del Negocio',
    },
    publicCard: {
      notFound: 'Tarjeta no encontrada',
      notFoundDesc: 'El enlace puede haber expirado o ser incorrecto.',
      saveContact: 'Guardar en Contactos',
      share: 'Compartir',
    },
    contacts: {
      contact: 'Contacto',
      addContact: 'Agregar Contacto',
      rentals: 'Rentas',
      sales: 'Ventas',
      houseSales: 'Ventas de Casas',
      investors: 'Inversores',
      referrals: 'Referidos',
      suppliers: 'Proveedores',
      others: 'Otros',
    },
    deal: {
      new: 'Nuevo',
      contacted: 'Contactado',
      negotiating: 'Negociando',
      won: 'Ganado',
      lost: 'Perdido',
    },
    leads: {
      title: 'Leads CRM',
      subtitle: 'Captura, califica y convierte oportunidades en clientes',
      addLead: 'Nuevo Lead',
      noLeads: 'Sin leads aún',
      noLeadsHint: 'Crea tu primer lead o importa desde Excel',
      name: 'Nombre',
      email: 'Email',
      phone: 'Teléfono',
      company: 'Empresa',
      position: 'Cargo',
      source: 'Fuente',
      estimatedValue: 'Valor estimado',
      stage: 'Etapa',
      tags: 'Etiquetas',
      notes: 'Notas',
      assignedTo: 'Asignado a',
      lastContact: 'Último contacto',
      nextAction: 'Próxima acción',
      kanban: 'Tablero',
      list: 'Lista',
      stages: {
        prospect: 'Prospecto',
        contacted: 'Contactado',
        qualified: 'Calificado',
        proposal: 'Propuesta',
        negotiation: 'Negociación',
        won: 'Ganado',
        lost: 'Perdido',
      },
      sources: {
        web: 'Web',
        referral: 'Referido',
        social: 'Redes Sociales',
        email: 'Email Marketing',
        cold_call: 'Llamada Fría',
        event: 'Evento',
        ads: 'Anuncios',
        portal: 'Portal Cliente',
        other: 'Otro',
      },
      aiEnrich: 'Enriquecer con IA',
      aiEnriching: 'Investigando con IA...',
      enrichSuccess: 'Lead enriquecido',
      convertTo: 'Convertir a',
      convertCustomer: 'Cliente POS',
      convertRealEstate: 'Cliente Inmobiliaria',
      convertContact: 'Contacto',
      createAppointment: 'Agendar Cita',
      createTask: 'Crear Tarea',
      createInvoice: 'Crear Factura',
      createQuote: 'Crear Presupuesto',
      addInteraction: 'Agregar Interacción',
      interactions: 'Interacciones',
      interactionType: 'Tipo',
      score: 'Score',
      hotLead: 'Lead Caliente',
      warmLead: 'Lead Tibio',
      coldLead: 'Lead Frío',
      filterByStage: 'Filtrar por etapa',
      filterBySource: 'Filtrar por fuente',
      totalPipeline: 'Pipeline Total',
      wonValue: 'Valor Ganado',
      conversionRate: 'Tasa de Conversión',
    },
    payrollTax: {
      country: 'País',
      taxSystem: 'Sistema Fiscal',
      taxId: 'Identificación Fiscal',
      taxIdLabel: {
        US: 'EIN / SSN',
        CO: 'NIT',
        MX: 'RFC',
        AR: 'CUIT',
        ES: 'NIF',
        CL: 'RUT',
        PE: 'RUC',
        BR: 'CNPJ',
        EC: 'RUC',
        DO: 'RNC',
        VE: 'RIF',
      },
      grossSalary: 'Salario Bruto',
      netSalary: 'Salario Neto',
      deductions: 'Deducciones',
      employerContrib: 'Aporte Empleador',
      employeeContrib: 'Aporte Empleado',
      breakdown: 'Desglose de Impuestos',
      configCountry: 'Configurar país',
      countryTaxAuthority: 'Autoridad Fiscal',
      authorities: {
        US: 'IRS (Internal Revenue Service)',
        CO: 'DIAN',
        MX: 'SAT',
        AR: 'AFIP',
        ES: 'Agencia Tributaria',
        CL: 'SII',
        PE: 'SUNAT',
        BR: 'Receita Federal',
        EC: 'SRI',
        DO: 'DGII',
        VE: 'SENIAT',
      },
    },
    cajaTabs: {
      sales: 'Ventas',
      cashFlow: 'Ingresos / Gastos',
      history: 'Historial',
      audit: 'Arqueo / Cierre',
      inventory: 'Inventario',
      reports: 'Reportes',
    },
    geo: {
      title: 'Geo-búsqueda de Propiedades',
      subtitle: 'Filtra por ciudad, código postal o dibuja un radio en el mapa',
      searchPlaceholder: 'Ciudad, código postal, dirección...',
      myLocation: 'Mi ubicación',
      allTypes: 'Todos los tipos',
      forSale: 'Venta',
      forRent: 'Alquiler',
      radius: 'Radio',
      openSearch: 'Geo-búsqueda',
      searching: 'Buscando...',
      found: 'propiedades encontradas',
      noResults: 'Sin resultados',
      tryWidening: 'Amplía el radio o busca otra zona.',
      locationDenied: 'No se pudo obtener tu ubicación. Activa los permisos.',
    },
    tour: {
      aiTour: 'AI Video Tour',
      generating: 'Generando guión con IA...',
      generatingHint: 'Analizando características y creando narración cinematográfica',
      error: 'No se pudo generar el tour',
      noImages: 'Esta propiedad no tiene fotos.',
      scriptError: 'Error generando el guión del tour.',
    },
    portal: {
      title: 'Portal del Cliente',
      welcomeMsg: 'Mensaje de bienvenida personalizado',
      publicLink: 'Link público',
      sendWhatsapp: 'Enviar por WhatsApp',
      openClientView: 'Abrir vista cliente',
      pause: 'Pausar',
      reactivate: 'Reactivar',
      propertiesToShow: 'Propiedades para mostrar',
      activity: 'Actividad del cliente',
      visits: 'Visitas',
      propertyViews: 'Vistas Prop.',
      favorites: 'Favoritos',
      messages: 'Mensajes',
      recentActivity: 'Actividad reciente',
      noActivity: 'Aún no hay actividad. Comparte el link.',
      saveChanges: 'Guardar cambios',
    },
    voice: {
      permBlocked: '🎙️ Chrome bloqueó el acceso al micrófono.\n\nPara habilitarlo:\n1. Haz clic en el candado 🔒 al lado de la URL.\n2. Elige "Configuración del sitio" → Micrófono → Permitir.\n3. Recarga la página.',
      permBlockedShort: '🎙️ Chrome bloqueó el acceso al micrófono.\n\nHaz clic en el candado 🔒 al lado de la URL → Configuración del sitio → Micrófono → Permitir. Luego recarga.',
      permError: 'No se pudo acceder al micrófono: ',
      noMic: '🎙️ No se detectó ningún micrófono. Verifica que esté conectado y que el sistema operativo permita el acceso a Chrome.',
    },
    facturas: {
      thisMonth: 'Este Mes',
      totalMonth: 'Total Mes',
      yearTotal: 'Total Año',
      searchPh: 'Buscar proveedor...',
      noInvoices: 'No hay facturas',
      noInvoicesFor: 'No tienes facturas guardadas para',
      addInvoice: 'Agregar Factura',
    },
    priceIndex: {
      title: 'Indice de Precios — Compara con la competencia',
      subtitle: 'Analiza tus precios con IA. Sé competitivo. Maximiza tu margen.',
      newAnalysis: 'Nuevo análisis',
      newTitle: 'Nuevo análisis de precio',
      analyze: 'Analizar con IA',
      analyzing: 'Analizando...',
      all: 'Todos',
      products: 'Productos',
      properties: 'Propiedades',
      kindProduct: 'Producto',
      kindProperty: 'Propiedad',
      itemNamePh: 'Ej: iPhone 16 Pro 256GB, Penthouse Manhattan 2BR',
      userPricePh: 'Tu precio actual',
      descPh: 'Descripción opcional (marca, tamaño, ubicación, características...)',
      manualComp: 'Competidores manuales (opcional)',
      addCompetitor: 'Agregar',
      competitorName: 'Nombre competidor',
      competitorPrice: 'Precio',
      emptyTitle: 'Sin análisis aún',
      empty: 'Crea tu primer análisis con el botón "Nuevo análisis" o pídele a Briefy.',
      detailEmptyTitle: 'Selecciona un análisis',
      detailEmpty: 'Elige un análisis de la izquierda o crea uno nuevo para ver el desglose completo.',
      indexLabel: 'Tu precio vs mercado promedio',
      vs: 'vs',
      aboveMarket: 'Estás por ENCIMA del mercado. Podrías perder ventas.',
      belowMarket: 'Estás por DEBAJO del mercado. Podrías subir precio sin perder demanda.',
      alignedMarket: 'Tu precio está alineado con el mercado.',
      recommendation: 'Recomendación',
      rec: { raise: 'Suba el precio', lower: 'Baje el precio', hold: 'Mantenga el precio' },
      marketRange: 'Rango de mercado',
      min: 'Mínimo',
      avg: 'Promedio',
      max: 'Máximo',
      competitors: 'Competidores',
      you: 'Tú',
      tipTitle: 'Tip',
      tip: 'También puedes preguntarle a Briefy: "¿mi café Latte a $5 está caro?" o "analiza el precio de mi penthouse a $450,000". Briefy hace el análisis automáticamente.',
      confirmDelete: '¿Borrar este análisis?',
      errorAnalyze: 'No se pudo analizar el precio. Inténtalo de nuevo.',
      compareBtn: 'Comparar precio',
    },
  
    customers: { noClients: 'No hay clientes', noProspects: 'No hay prospectos', tagVip: 'Cliente VIP', tagFreq: 'Cliente Frecuente', tagNew: 'Cliente Nuevo', tagInactive: 'Cliente Inactivo', statTotal: 'Total Clientes', statBirthdays: 'Cumpleaños Hoy', btnCategories: 'Categorías', btnProspect: 'Prospecto', btnImportPhone: 'Celular', searchPh: 'Buscar por nombre, teléfono o email...', vipBadge: 'VIP', vipTooltip: 'Gasto acumulado superior a $100,000' },
    purchases: { newSupplier: 'Nuevo Proveedor', newOrder: 'Nueva Orden', noOrders: 'No hay ordenes de compra', fPending: 'Pendientes', fApproved: 'Aprobadas', fReceived: 'Recibidas', fCancelled: 'Canceladas', statSuppliers: 'Proveedores', statOrders: 'Órdenes', statSpend: 'Gasto Mes', tabOrders: 'Órdenes de Compra' },
    bills: { noAccounts: 'No hay cuentas', noDebtors: 'No hay deudores registrados' },
    tasks: { statsBtn: 'Estadísticas', noTasks: 'No hay tareas creadas' },
    budget: { noBudgets: 'No tienes presupuestos configurados', noEstimates: 'No tienes estimados creados' },
    onboarding: {
      setupLabel: 'Configuración Guiada', title: 'Configuremos tu negocio', step: 'Paso', skip: 'Saltar',
      skipAll: 'Saltar configuración', skipStep: 'Omitir este paso', next: 'Siguiente', back: 'Atrás',
      industryStepTitle: '¿Cuál es tu tipo de negocio?', industryStepSubtitle: 'Esto personaliza tu panel y tus accesos rápidos.',
      industryNext: 'Siguiente', productStepTitle: 'Agrega tu primer producto o servicio',
      productStepSubtitle: 'Así podrás venderlo de inmediato en el Punto de Venta.', productName: 'Nombre',
      productNamePh: 'Ej: Corte de cabello, Café, Consulta...', productPrice: 'Precio', productStock: 'Inventario inicial',
      isService: 'Es un servicio (sin inventario)', productInvalid: 'Ingresa un nombre y un precio válido',
      productSaved: '¡Producto agregado!', clientStepTitle: 'Agrega tu primer cliente',
      clientStepSubtitle: 'Lleva el control de quién te compra.', clientName: 'Nombre del cliente',
      clientNamePh: 'Ej: Juan Pérez', clientPhone: 'Teléfono', clientEmail: 'Email',
      clientInvalid: 'Ingresa el nombre del cliente', clientSaved: '¡Cliente agregado!', clientLabel: 'Cliente',
      saleStepTitle: 'Registra tu primera transacción', saleStepSubtitle: 'Simula tu primera venta con los datos que acabas de crear.',
      saleSummary: 'Resumen de la venta', registerSale: 'Registrar venta', saleSaved: '¡Primera venta registrada!',
      saleNote: 'Primera venta - Configuración guiada', needProduct: 'Necesitas un producto para registrar una venta.',
      backToProduct: 'Volver a agregar producto', doneTitle: '¡Todo listo!',
      doneSubtitle: 'Tu cuenta ya tiene tu primer producto, cliente y venta. Así de fácil es usar BRIEFCASE.',
      goToDashboard: 'Ir al Dashboard', errorGeneric: 'Algo salió mal. Intenta de nuevo.',
    },
  },
  en: {
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      search: 'Search',
      loading: 'Loading...',
      noData: 'No data',
      confirm: 'Confirm',
      back: 'Back',
      today: 'Today',
      total: 'Total',
      actions: 'Actions',
      new: 'New',
      close: 'Close',
      yes: 'Yes',
      no: 'No',
      all: 'All',
      none: 'None',
      select: 'Select',
      download: 'Download',
      upload: 'Upload',
      send: 'Send',
      share: 'Share',
      view: 'View',
      manage: 'Manage',
      filter: 'Filter',
      sort: 'Sort',
      export: 'Export',
      import: 'Import',
      print: 'Print',
      copy: 'Copy',
      paste: 'Paste',
      refresh: 'Refresh',
      details: 'Details',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      pending: 'Pending',
      completed: 'Completed',
      date: 'Date',
      time: 'Time',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      notes: 'Notes',
      description: 'Description',
      amount: 'Amount',
      price: 'Price',
      quantity: 'Quantity',
      category: 'Category',
      type: 'Type',
      from: 'From',
      to: 'To',
      of: 'of',
      or: 'or',
      and: 'and',
      howToUse: 'How to use?',
      myBusiness: 'My Business',
      noData: 'No data',
      noResults: 'No results',
      noResultsDesc: 'No data to display',
      addFirst: 'Add first',
      tryAgain: 'Try again',
      next: 'Next',
      previous: 'Previous',
      finish: 'Finish',
      apply: 'Apply',
      reset: 'Reset',
      copy: 'Copy',
      duplicate: 'Duplicate',
      preview: 'Preview',
      generate: 'Generate',
      success: 'Success!',
      error: 'Error',
      warning: 'Warning',
      info: 'Info',
      required: 'Required',
      optional: 'Optional',
      selectOption: 'Select an option',
    },
    banners: {
      appointments: { title: 'Appointment System', subtitle: 'Manage appointments with clients', noAppointments: 'No appointments', },
      arqueo: { title: 'Cash Count', subtitle: 'Verify physical cash in the register', help: 'Count the physical cash in your register to verify it matches the system sales and incomes. You can run multiple counts per day.' },
      
      bills: { title: 'Bills', subtitle: 'Avoid late fees, pay on time', help: 'Track your bills to pay and your debtors.' },
      
      budget: { title: 'Budgets & Estimates', subtitle: 'Manage finances and quotes', help: 'Create budgets to control expenses and professional estimates for your clients.' },
      
      businesscard: { title: 'Business Card', subtitle: 'Design and share your professional card' },
      cajaregistradora: { title: 'My Accountant', subtitle: 'Your virtual finance office' },
      cashflow: { title: 'Cash Flow', subtitle: 'Visualize your money in and out', help: 'See the movement of money in your business: sales income, other income and expenses. The balance tells you whether you are in the black or in the red.' },
      
      cash: { title: "Today's Cash", subtitle: 'Daily income and expense control', help: 'Log your daily incomes and expenses. POS sales are automatically included.' },
      
      chat: { title: 'Communication', subtitle: 'Internal chat and video calls' },
      closing: { title: 'Cash Close-out', subtitle: 'Income statement and daily close' },
      companies: { title: 'My Companies', subtitle: 'Manage multiple corporations from one profile', noCompanies: 'No companies registered', },
      comparative: { title: 'Period Comparison', subtitle: 'Compare performance across periods', help: 'Compare your income, expenses and balance between the current and previous period. This helps you spot trends and patterns in your business.' },
      
      customers: { title: 'Customers & Prospects', subtitle: 'CRM to manage clients and opportunities', help: 'Manage your customer base, group by category, track sales prospects and view purchase history.' },
      
      expenseanalysis: { title: 'Expense Analysis', subtitle: 'Understand where your money goes' },
      facturas: { title: 'Invoice Archive', subtitle: 'Store and organize your invoices' },
      financialreports: { title: 'Financial Reports', subtitle: 'Analyze your business economic situation', help: 'Analyze your business performance. View income, expense, cash-flow reports and comparative charts by period.' },
      
      financialtools: { title: 'Financial Tools', subtitle: 'Analyze and optimize your finances' },
      news: { title: 'Live News', subtitle: 'Stay up to date with the business world' },
      pos: { title: 'Cash Register', subtitle: 'Search products, add to cart, and complete sale', help: "Search products, add them to the cart, apply discounts and complete the sale. Log cash income (manual) or use 'Close Register' at end of day." },
      
      payroll: { title: 'Payroll', subtitle: 'Manage employees and pay', help: 'Register employees, generate periodic payrolls, track attendance and compute pay automatically.' },
      
      pricing: { title: 'Plans and Pricing', subtitle: 'Choose the perfect plan for your business' },
      profitability: { title: 'Profitability Analysis', subtitle: 'Analyze profit by product', help: 'Know which products generate the most profit. Profit margin = (Profit / Revenue) x 100.' },
      
      projections: { title: 'Financial Projections', subtitle: 'Visualize the future of your business', help: 'Projections are calculated using your last 6 months of sales history.' },
      
      purchases: { title: 'Purchases & Suppliers', subtitle: 'Manage your purchase orders', help: 'Register suppliers, create purchase orders and track deliveries.', helpLong: 'Register suppliers, create purchase orders and track deliveries. Inventory updates automatically.' },
      
      salesgoals: { title: 'Sales Goals', subtitle: 'Set and monitor your objectives' },
      tasks: { title: 'Task Control', subtitle: 'Organize your day, save time', help: 'Create tasks with date and time, set reminders and organize by category.' },
      
      toolrelationships: { title: 'Relationship Map', subtitle: 'How tools connect with each other' },
      transport: { title: 'Transport / Fleet', subtitle: 'Vehicle and expense management' },
      contacts: { title: 'My Contacts', subtitle: 'Manage contacts and customers' },
      saleshistory: { title: 'Sales History', subtitle: 'Review your past sales' },
      admin: { title: 'Administration', subtitle: 'Administrative control panel' },
      install: { title: 'Install App', subtitle: 'Install BRIEFCASE on your device' },
      
      caja: { title: 'My Accountant', help: 'Your personal virtual accountant. Log incomes, expenses, services and sales. Run a daily close and see your P&L in real time.' },
      
      
      dashboard: { title: 'Dashboard', help: 'Business overview: Sales (silver), Income (gold), Expenses (orange) and Profit (green). Below you see this weeks sales chart.' },
      expenseAnalysis: { title: 'Expense Analysis', help: 'See how your expenses are distributed by category. Identify where you spend the most to make better financial decisions.' },
      financialTools: { title: 'Financial Tools', help: 'Here you can view cash flow, set sales goals, compare periods, analyze product profitability and export reports.' },
      
      
      
      salesGoals: { title: 'Sales Goals', help: 'Create weekly, monthly or yearly goals for your business. The system tracks your progress automatically based on completed sales.' },
      salesHistory: { title: 'Sales History', help: 'Browse all completed sales. Filter by date, view transaction details and send receipts via WhatsApp.' },
      
      
      
      
      inventory: { title: 'Inventory', help: 'Manage your products and services. Add new ones, edit existing ones, use the barcode scanner and generate labels.' },
      
      
      
      
    },
    tutorial: {
      skip: 'Skip',
      start: 'Get Started!',
      welcome: { title: 'Welcome!', desc: 'Your all-in-one ERP system.' },
      dashboard: { title: 'Dashboard', desc: 'Sales summary and statistics.' },
      pos: { title: 'Point of Sale', desc: 'Easy-to-use cash register.' },
      inventory: { title: 'Inventory', desc: 'Products and barcodes.' },
      realestate: { title: 'Real Estate', desc: 'Clients, properties, and E-Sign.' },
      esign: { title: 'E-Sign', desc: 'Sign documents wherever you are.' },
      contacts: { title: 'Contacts', desc: 'Import from Excel or your phone.' },
      finances: { title: 'Finances', desc: 'Income and expense control.' },
      complete: { title: 'All Set!', desc: 'Success in your business!' },
    },
    auth: {
      login: 'Login',
      register: 'Register',
      logout: 'Logout',
      email: 'Email',
      password: 'Password',
      businessName: 'Business Name',
      taxConfig: 'Tax Configuration',
      applyTax: 'Apply tax to sales',
      selectRegion: 'Select your region',
      taxRatePct: 'Tax rate (%)',
      taxNameLabel: 'Tax name',
      invoicePreview: 'Invoice preview:',
      accountInfo: 'Account Info',
      plan: 'Plan',
      planBusiness: 'Business',
      planFree: 'Free',
      subSuccess: 'Subscription Successful!',
      subSuccessDesc: 'Your plan has been updated. Enjoy all features.',
      welcomeBack: 'Welcome Back',
      createAccount: 'Create Account',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      forgotPassword: 'Forgot your password?',
      resetPassword: 'Reset Password',
    },
    nav: {
      dashboard: 'Dashboard',
      posUnified: 'Cash / POS',
      groupCrm: 'CRM & Clients',
      groupOps: 'Operations',
      groupMore: 'More',
      groupAdmin: 'Administration',
      pos: 'Point of Sale',
      posGroup: 'Point of Sale',
      myAccountant: 'My Accountant',
      cashRegister: 'Cash Register',
      cashIncome: 'Cash Income',
      salesHistory: 'Sales History',
      cashAudit: 'Cash Reconciliation',
      inventory: 'Inventory',
      cash: 'Daily Cash',
      closing: 'Cash Closing',
      settings: 'Settings',
      realEstate: 'Real Estate',
      clients: 'Clients',
      contacts: 'Contacts',
      news: 'News',
      finances: 'Finances',
      financesDashboard: 'Financial Dashboard',
      cashFlow: 'Cash Flow',
      salesGoals: 'Sales Goals',
      expenseAnalysis: 'Expense Analysis',
      comparative: 'Comparative',
      profitability: 'Profitability',
      projections: 'Projections',
      budget: 'Budget',
      payroll: 'Payroll',
      invoices: 'Invoices',
      appointments: 'Appointments',
      transport: 'Transport',
      reports: 'Reports',
      admin: 'Administration',
      revenue: 'Revenue (Admin)',
      chat: 'Communication',
      bills: 'Bills',
      tasks: 'Tasks',
      notes: 'My Notes',
      priceIndex: 'Price Index',
      services: 'Services',
      purchases: 'Purchases',
      companies: 'Companies',
      toolMap: 'Relationship Map',
      businessCard: 'Business Card',
      pricing: 'Plans',
      installApp: 'Install App',
    },
    dashboard: {
      title: 'Dashboard',
      subtitle: 'Your business overview',
      todaySales: "Today's Sales",
      controlCenter: 'Control Center',
      goodMorning: 'Good morning',
      goodAfternoon: 'Good afternoon',
      goodEvening: 'Good evening',
      briefySays: 'Briefy says',
      todayAgenda: "Today's Agenda",
      noEventsToday: 'No appointments or tasks today. Schedule something to get started.',
      viewAll: 'View all',
      chooseIndustry: 'Choose your industry',
      industryHint: 'Adapt your Control Center with imagery and shortcuts for your business type.',
      industrySaved: 'Control Center personalized',
      vsYesterday: 'vs yesterday',
      salesUp: 'Your sales are up',
      salesDown: 'Your sales are down',
      thisWeek: 'this week',
      briefyDefault: 'Today is a great day to grow your business.',
      apptLabel: 'New Appointment',
      tutorialBtn: 'View tutorial',
      weekTotal: 'Week total',
      briefyRole: 'AI Assistant · Online',
      talkToBriefy: 'Talk to Briefy',
      summaryLine: 'Here is your business summary.',
      period_today: 'Today',
      period_7d: '7 days',
      period_30d: '30 days',
      revenueOverview: 'Revenue Overview',
      incomeVsExpenses: 'Income vs Expenses',
      recentTransactions: 'Recent Transactions',
      pendingInvoices: 'Pending Invoices',
      noTransactions: 'No transactions yet',
      noPendingInvoices: 'No pending invoices',
      vsPrev: 'vs previous period',
      todayIncome: "Today's Income",
      todayExpenses: "Today's Expenses",
      netProfit: 'Net Profit',
      salesCount: 'Number of Sales',
      lowStock: 'Low Stock Products',
      weeklyStats: 'Weekly Statistics',
      sales: 'SALES',
      income: 'INCOME',
      expenses: 'EXPENSES',
      profit: 'PROFIT',
      salesLabel: 'sales',
      saleSingular: 'sale',
      loadError: 'Some data could not be loaded. Please try again.',
      welcome: 'Welcome',
      quickActions: 'Quick Actions',
      recentActivity: 'Recent Activity',
      monthlyOverview: 'Monthly Overview',
      topProducts: 'Top Selling Products',
      pendingTasks: 'Pending Tasks',
    },
    realEstate: {
      title: 'Real Estate',
      subtitle: 'Manage properties and clients',
      properties: 'Properties',
      clients: 'Clients',
      coBrokers: 'Co-Brokers',
      tracking: 'Tracking',
      forSale: 'For Sale',
      forRent: 'For Rent',
      buyers: 'Buyers',
      tenants: 'Tenants',
      sellers: 'Sellers',
      activeProspects: 'Active',
      closed: 'Closed',
      documents: 'Documents',
      addProperty: 'Add Property',
      addClient: 'Add Client',
      addBroker: 'Add Co-Broker',
      propertyType: 'Property Type',
      bedrooms: 'Bedrooms',
      bathrooms: 'Bathrooms',
      area: 'Area',
      location: 'Location',
      budget: 'Budget',
      activeProspect: 'Active Prospect',
      incompleteDoc: 'Incomplete Documentation',
      completeDoc: 'Complete Documentation',
      programBeneficiary: 'Program Beneficiary',
      importFromExcel: 'Import from Excel',
      importFromPhone: 'Import from Phone',
      howToUse: 'How to use?',
      interaction: 'Interaction',
      addInteraction: 'Add Interaction',
    },
    contacts: {
      title: 'Contacts',
      subtitle: 'Manage your contact network',
      addContact: 'Add Contact',
      allContacts: 'All Contacts',
      favorites: 'Favorites',
      recent: 'Recent',
      company: 'Company',
      position: 'Position',
      tags: 'Tags',
      searchPlaceholder: 'Search by name, phone, email or company...',
    },
    finances: {
      title: 'Financial Center',
      subtitle: 'Manage your finances',
      cashFlow: 'Cash Flow',
      bills: 'Bills',
      receivables: 'Receivables',
      budget: 'Budgets',
      reports: 'Financial Reports',
      income: 'Income',
      expenses: 'Expenses',
      balance: 'Balance',
      profit: 'Profit',
      loss: 'Loss',
      revenue: 'Revenue',
      costs: 'Costs',
      operatingExpenses: 'Operating Expenses',
      netIncome: 'Net Income',
      grossProfit: 'Gross Profit',
    },
    documents: {
      title: 'Documents',
      subtitle: 'Manage files and signatures',
      upload: 'Upload Document',
      sign: 'Sign',
      download: 'Download',
      signed: 'Signed',
      unsigned: 'Unsigned',
      pending: 'Pending',
      sendForSignature: 'Send for Signature',
      eSign: 'Electronic Signature',
      downloadSigned: 'Download Signed',
      signatureDate: 'Signature Date',
      signedBy: 'Signed by',
      placeSignature: 'Place your signature',
      drawSignature: 'Draw Your Signature',
      clearSignature: 'Clear',
      saveSignature: 'Save',
      signatures: 'Signatures',
      tapToPlace: 'Tap where you want the signature',
      dragToMove: 'Drag to move',
      size: 'Size',
    },
    pos: {
      title: 'Point of Sale',
      searchProduct: 'Search product...',
      cart: 'Cart',
      emptyCart: 'Empty cart',
      subtotal: 'Subtotal',
      discount: 'Discount',
      tax: 'Tax',
      taxableBase: 'Taxable base',
      total: 'Total',
      completeSale: 'Complete Sale',
      paymentMethod: 'Payment method',
      cash: 'Cash',
      card: 'Card',
      transfer: 'Transfer',
      saleComplete: 'Sale completed',
      addToCart: 'Add to cart',
      removeFromCart: 'Remove from cart',
      checkout: 'Checkout',
      receipt: 'Receipt',
    },
    briefySettings: {
      desc: 'Control how Briefy accompanies you inside BRIEFCASE.',
      interactive: 'Briefy Interactive Mode',
      interactiveDesc: 'Briefy appears as a living character inside the app',
      idle: 'Idle interactions',
      idleDesc: 'Briefy peeks in after ~1 minute of no activity',
      haptics: 'Haptic feedback',
      hapticsDesc: 'Soft vibration when Briefy appears (mobile only)',
      sound: 'Sound effects',
      soundDesc: 'Subtle sound when Briefy appears',
      animations: 'Briefy animations',
      animationsDesc: 'Entrance, movement and gesture animations',
    },
    inventory: {
      title: 'Inventory',
      labelsBtn: 'Labels',
      addProduct: 'Add Product',
      editProduct: 'Edit Product',
      productName: 'Product name',
      description: 'Description',
      price: 'Sale price',
      cost: 'Cost',
      stock: 'Stock',
      category: 'Category',
      isService: 'Is a service',
      sku: 'SKU',
      products: 'Products',
      services: 'Services',
      lowStock: 'Low Stock',
      outOfStock: 'Out of Stock',
      inStock: 'In Stock',
    },
    payroll: {
      title: 'Payroll',
      subtitle: 'Manage employees and payments',
      employees: 'Employees',
      addEmployee: 'Add Employee',
      salary: 'Salary',
      bonus: 'Bonus',
      deductions: 'Deductions',
      netPay: 'Net Pay',
      payPeriod: 'Pay Period',
      generatePayroll: 'Generate Payroll',
      earnings: 'Earnings',
      taxWithholding: 'Tax Withholding', noRecords: 'No payroll records', noAttendance: 'No attendance records this month', noPaystubs: 'No pay stubs generated', },
    appointments: {
      title: 'Appointments',
      subtitle: 'Manage your appointments with clients',
      schedule: 'Schedule Appointment',
      upcoming: 'Upcoming',
      past: 'Past',
      cancelled: 'Cancelled',
      reschedule: 'Reschedule',
      client: 'Client',
      dateTime: 'Date & Time',
      location: 'Location',
      reminder: 'Reminder',
    },
    news: {
      title: 'News',
      subtitle: 'Stay informed',
      createPost: 'Create Post',
      feed: 'Feed',
      myPosts: 'My Posts',
      like: 'Like',
      comment: 'Comment',
      share: 'Share',
      searchNews: 'Search news...',
    },
    settings: {
      title: 'Settings',
      currency: 'Currency',
      language: 'Language',
      businessName: 'Business Name',
      profile: 'Profile',
      account: 'Account',
      notifications: 'Notifications',
      security: 'Security',
      theme: 'Theme',
      darkMode: 'Dark Mode',
      lightMode: 'Light Mode',
      changePassword: 'Change Password',
      twoFactor: 'Two-Factor Authentication',
    },
    errors: {
      required: 'This field is required',
      invalidEmail: 'Invalid email',
      invalidPhone: 'Invalid phone',
      minLength: 'Minimum {0} characters',
      maxLength: 'Maximum {0} characters',
      networkError: 'Connection error',
      serverError: 'Server error',
      notFound: 'Not found',
      unauthorized: 'Unauthorized',
      forbidden: 'Access denied',
      loadError: 'Error loading',
      saveError: 'Error saving',
      deleteError: 'Error deleting',
    },
    success: {
      saved: 'Saved successfully',
      deleted: 'Deleted successfully',
      updated: 'Updated successfully',
      created: 'Created successfully',
      sent: 'Sent successfully',
      copied: 'Copied to clipboard',
    },
    tutorial: {
      welcome: 'Welcome to BRIEFCASE',
      skip: 'Skip',
      next: 'Next',
      previous: 'Previous',
      finish: 'Finish',
      step: 'Step',
    },
    categories: {
      all: 'All Categories',
      manage: 'Manage Categories',
    },
    ui: {
      description: 'Description',
      category: 'Category',
      phone: 'Phone',
      address: 'Address',
      location: 'Location',
      period: 'Period',
      commission: 'Commission',
      code: 'Code',
      client: 'Client',
      clientName: 'Client name',
      vehicle: 'Vehicle',
      type: 'Type',
      newConversation: 'New Conversation',
      online: 'Online',
      noMessages: 'No messages',
      startConversation: 'Start the conversation',
      selectConversation: 'Select a conversation',
      noUsersAvailable: 'No users available',
      searchUsers: 'Search users...',
      noConversations: 'No conversations',
      noDocuments: 'No documents',
      noVehiclesRegistered: 'No vehicles registered',
      noExpensesRegistered: 'No expenses registered',
      noPropertiesRegistered: 'No properties registered',
      noClientsRegistered: 'No clients registered',
      noContactsRegistered: 'No contacts registered',
      noInvoicesRegistered: 'No invoices registered',
      noPaymentsRegistered: 'No payments registered',
      noTasksRegistered: 'No tasks registered',
      noEmployeesRegistered: 'No employees registered',
      noBudgetsRegistered: 'No budgets registered',
      noEstimatesRegistered: 'No estimates registered',
      noPurchasesRegistered: 'No purchases registered',
      noAppointmentsRegistered: 'No appointments registered',
      noSalesRegistered: 'No sales registered',
      noProductsRegistered: 'No products registered',
      noResults: 'No results',
      noMovementsToday: 'No movements for this day',
      addFirstProperty: '+ Add first property',
      addFirstClient: '+ Add first client',
      addFirstContact: '+ Add first contact',
      addFirstItem: '+ Add first',
      whatsappNumber: 'WhatsApp number',
      avgRating: 'Average Rating',
      yearTotal: 'Year Total',
      monthTotal: 'Month Total',
      dayTotal: 'Day Total',
      bonus: 'Bonus',
      medicalInsurance: 'Health Insurance',
      employeeInfo: 'EMPLOYEE INFO',
      periodInfo: 'PERIOD INFO',
      validUntil: 'Valid until',
      validityDays: 'Validity days',
      termsConditions: 'Terms & Conditions',
      termsPlaceholder: 'Terms and conditions...',
      addItem: 'Add item',
      newBudget: 'New Budget',
      newEstimate: 'New Estimate',
      selectCategory: 'Select a category',
      uncategorized: 'Uncategorized',
      allVehicles: 'All vehicles',
      clientType: 'Client Type',
      company: 'Company',
      active: 'Active',
      inactive: 'Inactive',
      pending: 'Pending',
      completed: 'Completed',
      cancelled: 'Cancelled',
      paid: 'Paid',
      unpaid: 'Unpaid',
      total: 'Total',
      subtotal: 'Subtotal',
      tax: 'Tax',
      discount: 'Discount',
      quantity: 'Quantity',
      price: 'Price',
      stock: 'Stock',
      sku: 'SKU',
      barcode: 'Barcode',
      profit: 'Profit',
      revenue: 'Revenue',
      expense: 'Expense',
      payment: 'Payment',
      method: 'Method',
      status: 'Status',
      notes: 'Notes',
      addNotes: 'Add notes...',
      pickDate: 'Pick date',
      pickTime: 'Pick time',
      uploadImage: 'Upload Image',
      changeImage: 'Change Image',
      removeImage: 'Remove Image',
      saving: 'Saving...',
      deleting: 'Deleting...',
      uploading: 'Uploading...',
      processing: 'Processing...',
      retry: 'Retry',
      tryAgain: 'Try again',
      seeAll: 'See all',
      seeMore: 'See more',
      seeLess: 'See less',
      thisWeek: 'This week',
      thisMonth: 'This month',
      thisYear: 'This year',
      lastWeek: 'Last week',
      lastMonth: 'Last month',
      lastYear: 'Last year',
      today: 'Today',
      yesterday: 'Yesterday',
      tomorrow: 'Tomorrow',
      confirmDelete: 'Delete?',
      confirmDeleteDesc: 'This action cannot be undone',
      saved: 'Saved',
      created: 'Created',
      updated: 'Updated',
      deleted: 'Deleted',
      errorOccurred: 'An error occurred',
      tryLater: 'Try again later',
      requiredField: 'Required field',
      invalidEmail: 'Invalid email',
      invalidPhone: 'Invalid phone',
      passwordTooShort: 'Password too short',
      passwordsDontMatch: 'Passwords do not match',
      activeEmployees: 'Active Employees',
      generatePayroll: 'Generate Payroll',
      monthPayroll: 'Month Payroll',
      employees: 'Employees',
      payrollPayments: 'Payroll Payments',
      payStubs: 'Pay Stubs',
      attendance: 'Attendance',
      noEmployees: 'No employees',
      activos: 'Active',
      inactivos: 'Inactive',
      todos: 'All',
      todosCategoria: 'All',
    },
    settings: {
      title: 'Settings',
      subtitle: 'Personalize your account and preferences',
      profilePhoto: 'Profile Photo',
      changePhoto: 'Change Photo',
      photoFormats: 'JPG, PNG, WEBP or GIF. Max 5MB.',
      businessInfo: 'Business Information',
      contactInfo: 'Contact Information',
      businessAddress: 'Business Address',
      businessPhone: 'Business Phone',
      businessEmail: 'Business Email',
      businessFax: 'Business Fax',
      currency: 'Currency',
      language: 'Language',
      tax: 'Tax',
      taxName: 'Tax Name',
      taxRate: 'Tax Rate',
      taxEnabled: 'Tax Enabled',
      twoFactor: 'Two-Factor Authentication',
      changePassword: 'Change Password',
      businessName: 'Business Name',
    },
    publicCard: {
      notFound: 'Card not found',
      notFoundDesc: 'The link may have expired or be incorrect.',
      saveContact: 'Save to Contacts',
      share: 'Share',
    },
    contacts: {
      contact: 'Contact',
      addContact: 'Add Contact',
      rentals: 'Rentals',
      sales: 'Sales',
      houseSales: 'House Sales',
      investors: 'Investors',
      referrals: 'Referrals',
      suppliers: 'Suppliers',
      others: 'Others',
    },
    deal: {
      new: 'New',
      contacted: 'Contacted',
      negotiating: 'Negotiating',
      won: 'Won',
      lost: 'Lost',
    },
    leads: {
      title: 'CRM Leads',
      subtitle: 'Capture, qualify and convert opportunities into customers',
      addLead: 'New Lead',
      noLeads: 'No leads yet',
      noLeadsHint: 'Create your first lead or import from Excel',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      company: 'Company',
      position: 'Position',
      source: 'Source',
      estimatedValue: 'Estimated value',
      stage: 'Stage',
      tags: 'Tags',
      notes: 'Notes',
      assignedTo: 'Assigned to',
      lastContact: 'Last contact',
      nextAction: 'Next action',
      kanban: 'Board',
      list: 'List',
      stages: {
        prospect: 'Prospect',
        contacted: 'Contacted',
        qualified: 'Qualified',
        proposal: 'Proposal',
        negotiation: 'Negotiation',
        won: 'Won',
        lost: 'Lost',
      },
      sources: {
        web: 'Website',
        referral: 'Referral',
        social: 'Social Media',
        email: 'Email Marketing',
        cold_call: 'Cold Call',
        event: 'Event',
        ads: 'Ads',
        portal: 'Client Portal',
        other: 'Other',
      },
      aiEnrich: 'Enrich with AI',
      aiEnriching: 'Researching with AI...',
      enrichSuccess: 'Lead enriched',
      convertTo: 'Convert to',
      convertCustomer: 'POS Customer',
      convertRealEstate: 'Real Estate Client',
      convertContact: 'Contact',
      createAppointment: 'Schedule appointment',
      createTask: 'Create task',
      createInvoice: 'Create invoice',
      createQuote: 'Create quote',
      addInteraction: 'Add interaction',
      interactions: 'Interactions',
      interactionType: 'Type',
      score: 'Score',
      hotLead: 'Hot Lead',
      warmLead: 'Warm Lead',
      coldLead: 'Cold Lead',
      filterByStage: 'Filter by stage',
      filterBySource: 'Filter by source',
      totalPipeline: 'Total Pipeline',
      wonValue: 'Won Value',
      conversionRate: 'Conversion Rate',
    },
    payrollTax: {
      country: 'Country',
      taxSystem: 'Tax System',
      taxId: 'Tax ID',
      taxIdLabel: { US: 'EIN / SSN', CO: 'NIT', MX: 'RFC', AR: 'CUIT', ES: 'NIF', CL: 'RUT', PE: 'RUC', BR: 'CNPJ', EC: 'RUC', DO: 'RNC', VE: 'RIF' },
      grossSalary: 'Gross Salary',
      netSalary: 'Net Salary',
      deductions: 'Deductions',
      employerContrib: 'Employer Contribution',
      employeeContrib: 'Employee Contribution',
      breakdown: 'Tax Breakdown',
      configCountry: 'Configure country',
      countryTaxAuthority: 'Tax Authority',
      authorities: {
        US: 'IRS (Internal Revenue Service)', CO: 'DIAN', MX: 'SAT', AR: 'AFIP', ES: 'Agencia Tributaria',
        CL: 'SII', PE: 'SUNAT', BR: 'Receita Federal', EC: 'SRI', DO: 'DGII', VE: 'SENIAT'
      },
    },
    cajaTabs: { sales: 'Sales', cashFlow: 'Income / Expenses', history: 'History', audit: 'Audit / Closing', inventory: 'Inventory', reports: 'Reports' },
    geo: {
      title: 'Property Geo-search',
      subtitle: 'Filter by city, postal code or draw a radius on the map',
      searchPlaceholder: 'City, postal code, address...',
      myLocation: 'My location',
      allTypes: 'All types',
      forSale: 'For sale',
      forRent: 'For rent',
      radius: 'Radius',
      openSearch: 'Geo-search',
      searching: 'Searching...',
      found: 'properties found',
      noResults: 'No results',
      tryWidening: 'Widen the radius or try another area.',
      locationDenied: 'Could not get your location. Enable permissions.',
    },
    tour: {
      aiTour: 'AI Video Tour',
      generating: 'Generating script with AI...',
      generatingHint: 'Analyzing features and creating cinematic narration',
      error: 'Could not generate tour',
      noImages: 'This property has no photos.',
      scriptError: 'Error generating tour script.',
    },
    portal: {
      title: 'Client Portal',
      welcomeMsg: 'Personalized welcome message',
      publicLink: 'Public link',
      sendWhatsapp: 'Send via WhatsApp',
      openClientView: 'Open client view',
      pause: 'Pause',
      reactivate: 'Reactivate',
      propertiesToShow: 'Properties to show',
      activity: 'Client activity',
      visits: 'Visits',
      propertyViews: 'Property views',
      favorites: 'Favorites',
      messages: 'Messages',
      recentActivity: 'Recent activity',
      noActivity: 'No activity yet. Share the link.',
      saveChanges: 'Save changes',
    },
    briefy: {
      online: 'AI Assistant · Online',
      typing: 'Typing...',
      placeholder: 'Type your question...',
      startHint: 'Ask me how to use any tool',
      newConv: 'New conversation',
      error: '⚠ Sorry, an error occurred. Please try again.',
      toggleBadge: 'AI Assistant',
      toggleDesc: 'Your floating AI assistant available across every tool. Answers questions, explains flows and guides you step by step.',
      tooltipTitle: 'Why "Briefy"?',
      tooltipBrief: 'instant executive briefs',
      tooltipFamily: 'I live inside the BRIEFCASE',
      tooltipBriefly: 'brief, fast, frictionless',
      tool: {
        lead: 'Lead',
        customer: 'Customer',
        contact: 'Contact',
        task: 'Task',
        appointment: 'Appointment',
        search: 'Search',
        summary: 'Summary',
        recent: 'Recent',
      },
    },
    voice: {
      permBlocked: '🎙️ Chrome blocked microphone access.\n\nTo enable it:\n1. Click the 🔒 lock icon next to the URL.\n2. Choose "Site settings" → Microphone → Allow.\n3. Reload the page.',
      permBlockedShort: '🎙️ Chrome blocked microphone access.\n\nClick the 🔒 lock icon next to the URL → Site settings → Microphone → Allow. Then reload.',
      permError: 'Could not access microphone: ',
      noMic: '🎙️ No microphone detected. Make sure it is connected and that the OS allows Chrome to use it.',
    },
    facturas: {
      thisMonth: 'This Month',
      totalMonth: 'Monthly Total',
      yearTotal: 'Yearly Total',
      searchPh: 'Search supplier...',
      noInvoices: 'No invoices',
      noInvoicesFor: 'You have no invoices saved for',
      addInvoice: 'Add Invoice',
    },
    priceIndex: {
      title: 'Price Index — Benchmark against competitors',
      subtitle: 'Analyze your prices with AI. Stay competitive. Maximize margin.',
      newAnalysis: 'New analysis',
      newTitle: 'New price analysis',
      analyze: 'Analyze with AI',
      analyzing: 'Analyzing...',
      all: 'All',
      products: 'Products',
      properties: 'Properties',
      kindProduct: 'Product',
      kindProperty: 'Property',
      itemNamePh: 'e.g. iPhone 16 Pro 256GB, Manhattan 2BR Penthouse',
      userPricePh: 'Your current price',
      descPh: 'Optional description (brand, size, location, features...)',
      manualComp: 'Manual competitors (optional)',
      addCompetitor: 'Add',
      competitorName: 'Competitor name',
      competitorPrice: 'Price',
      emptyTitle: 'No analyses yet',
      empty: 'Create your first analysis with the "New analysis" button or ask Briefy.',
      detailEmptyTitle: 'Select an analysis',
      detailEmpty: 'Pick an analysis on the left or create a new one to see the full breakdown.',
      indexLabel: 'Your price vs market average',
      vs: 'vs',
      aboveMarket: 'You are ABOVE the market. You may lose sales.',
      belowMarket: 'You are BELOW the market. You could raise your price without losing demand.',
      alignedMarket: 'Your price is aligned with the market.',
      recommendation: 'Recommendation',
      rec: { raise: 'Raise price', lower: 'Lower price', hold: 'Hold price' },
      marketRange: 'Market range',
      min: 'Min',
      avg: 'Average',
      max: 'Max',
      competitors: 'Competitors',
      you: 'You',
      tipTitle: 'Tip',
      tip: 'You can also ask Briefy: "is my $5 Latte too expensive?" or "analyze the price of my $450,000 penthouse". Briefy runs the analysis automatically.',
      confirmDelete: 'Delete this analysis?',
      errorAnalyze: 'Could not analyze the price. Try again.',
      compareBtn: 'Compare price',
    },
  
    customers: { noClients: 'No clients', noProspects: 'No prospects', tagVip: 'VIP Client', tagFreq: 'Frequent Client', tagNew: 'New Client', tagInactive: 'Inactive Client', statTotal: 'Total Clients', statBirthdays: 'Birthdays Today', btnCategories: 'Categories', btnProspect: 'Prospect', btnImportPhone: 'Phone', searchPh: 'Search by name, phone or email...', vipBadge: 'VIP', vipTooltip: 'Accumulated spend over $100,000' },
    purchases: { newSupplier: 'New Supplier', newOrder: 'New Order', noOrders: 'No purchase orders', fPending: 'Pending', fApproved: 'Approved', fReceived: 'Received', fCancelled: 'Cancelled', statSuppliers: 'Suppliers', statOrders: 'Orders', statSpend: 'Monthly Spend', tabOrders: 'Purchase Orders' },
    bills: { noAccounts: 'No accounts', noDebtors: 'No debtors registered' },
    tasks: { statsBtn: 'Stats', noTasks: 'No tasks created' },
    budget: { noBudgets: 'You have no budgets configured', noEstimates: 'You have no estimates created' },
    onboarding: {
      setupLabel: 'Guided Setup', title: "Let's set up your business", step: 'Step', skip: 'Skip',
      skipAll: 'Skip setup', skipStep: 'Skip this step', next: 'Next', back: 'Back',
      industryStepTitle: 'What type of business do you run?', industryStepSubtitle: 'This personalizes your dashboard and quick actions.',
      industryNext: 'Next', productStepTitle: 'Add your first product or service',
      productStepSubtitle: 'So you can sell it right away at the Point of Sale.', productName: 'Name',
      productNamePh: 'E.g.: Haircut, Coffee, Consultation...', productPrice: 'Price', productStock: 'Initial stock',
      isService: 'This is a service (no inventory)', productInvalid: 'Enter a name and a valid price',
      productSaved: 'Product added!', clientStepTitle: 'Add your first client',
      clientStepSubtitle: 'Keep track of who buys from you.', clientName: 'Client name',
      clientNamePh: 'E.g.: John Smith', clientPhone: 'Phone', clientEmail: 'Email',
      clientInvalid: 'Enter the client name', clientSaved: 'Client added!', clientLabel: 'Client',
      saleStepTitle: 'Record your first transaction', saleStepSubtitle: 'Simulate your first sale with the data you just created.',
      saleSummary: 'Sale summary', registerSale: 'Register sale', saleSaved: 'First sale registered!',
      saleNote: 'First sale - Guided setup', needProduct: 'You need a product to register a sale.',
      backToProduct: 'Go back and add a product', doneTitle: 'All set!',
      doneSubtitle: 'Your account already has your first product, client, and sale. That is how easy BRIEFCASE is.',
      goToDashboard: 'Go to Dashboard', errorGeneric: 'Something went wrong. Please try again.',
    },
  },
  pt: {
    common: {
      save: 'Salvar',
      cancel: 'Cancelar',
      delete: 'Excluir',
      edit: 'Editar',
      add: 'Adicionar',
      search: 'Buscar',
      loading: 'Carregando...',
      noData: 'Sem dados',
      confirm: 'Confirmar',
      back: 'Voltar',
      today: 'Hoje',
      total: 'Total',
      actions: 'Acoes',
      new: 'Novo',
      close: 'Fechar',
      yes: 'Sim',
      no: 'Nao',
      all: 'Todos',
      none: 'Nenhum',
      select: 'Selecionar',
      download: 'Baixar',
      upload: 'Enviar',
      send: 'Enviar',
      share: 'Compartilhar',
      view: 'Ver',
      manage: 'Gerenciar',
      filter: 'Filtrar',
      sort: 'Ordenar',
      export: 'Exportar',
      import: 'Importar',
      print: 'Imprimir',
      copy: 'Copiar',
      paste: 'Colar',
      refresh: 'Atualizar',
      details: 'Detalhes',
      status: 'Status',
      active: 'Ativo',
      inactive: 'Inativo',
      pending: 'Pendente',
      completed: 'Concluido',
      date: 'Data',
      time: 'Hora',
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefone',
      address: 'Endereco',
      notes: 'Notas',
      description: 'Descricao',
      amount: 'Valor',
      price: 'Preco',
      quantity: 'Quantidade',
      category: 'Categoria',
      type: 'Tipo',
      from: 'De',
      to: 'Ate',
      of: 'de',
      or: 'ou',
      and: 'e',
      howToUse: 'Como usar?',
    },
    banners: {
      appointments: { title: 'Sistema de Agendamentos', subtitle: 'Gerencie seus agendamentos com clientes', noAppointments: 'Sem compromissos', },
      arqueo: { title: 'Contagem de Caixa', subtitle: 'Verifique o dinheiro físico no caixa', help: 'Conte o dinheiro físico no seu caixa para verificar se coincide com as vendas e receitas do sistema.' },
      
      bills: { title: 'Contas a Pagar', subtitle: 'Evite juros, pague em dia', help: 'Registre suas contas a pagar e controle devedores.' },
      
      budget: { title: 'Orçamentos & Estimativas', subtitle: 'Gerencie suas finanças e cotações', help: 'Crie orçamentos para controlar despesas e estimativas profissionais.' },
      
      businesscard: { title: 'Cartão de Visita', subtitle: 'Crie e compartilhe seu cartão profissional' },
      cajaregistradora: { title: 'Meu Contador', subtitle: 'Seu escritório virtual de finanças' },
      cashflow: { title: 'Fluxo de Caixa', subtitle: 'Visualize entradas e saídas de dinheiro', help: 'Veja a movimentação de dinheiro do seu negócio: receitas de vendas, outras receitas e despesas.' },
      
      cash: { title: 'Caixa do Dia', subtitle: 'Controle de receitas e despesas diárias', help: 'Registre suas receitas e despesas diárias. As vendas do POS são somadas automaticamente.' },
      
      chat: { title: 'Comunicação', subtitle: 'Chat interno e videochamadas' },
      closing: { title: 'Fechamento de Caixa', subtitle: 'Demonstrativo e fechamento diário' },
      companies: { title: 'Minhas Empresas', subtitle: 'Gerencie várias corporações em um perfil', noCompanies: 'Sem empresas cadastradas', },
      comparative: { title: 'Comparativo de Períodos', subtitle: 'Compare o desempenho entre períodos', help: 'Compare suas receitas, despesas e saldo entre o período atual e o anterior.' },
      
      customers: { title: 'Clientes e Prospectos', subtitle: 'CRM para gerenciar clientes e oportunidades', help: 'Gerencie sua base de clientes, agrupe por categorias e acompanhe prospects.' },
      
      expenseanalysis: { title: 'Análise de Despesas', subtitle: 'Entenda para onde vai o seu dinheiro' },
      facturas: { title: 'Arquivo de Faturas', subtitle: 'Salve e organize suas faturas' },
      financialreports: { title: 'Relatórios Financeiros', subtitle: 'Análise da situação econômica do negócio', help: 'Analise o desempenho do seu negócio.' },
      
      financialtools: { title: 'Ferramentas Financeiras', subtitle: 'Analise e otimize suas finanças' },
      news: { title: 'Notícias ao Vivo', subtitle: 'Fique atualizado com o mundo dos negócios' },
      pos: { title: 'Caixa Registradora', subtitle: 'Busque produtos, adicione ao carrinho e finalize a venda', help: 'Pesquise produtos, adicione ao carrinho, aplique descontos e finalize a venda.' },
      
      payroll: { title: 'Folha de Pagamento', subtitle: 'Gerencie funcionários e pagamentos', help: 'Cadastre funcionários, gere folhas periódicas e controle a presença.' },
      
      pricing: { title: 'Planos e Preços', subtitle: 'Escolha o plano ideal para seu negócio' },
      profitability: { title: 'Análise de Rentabilidade', subtitle: 'Analise os lucros por produto', help: 'Descubra quais produtos geram mais lucro.' },
      
      projections: { title: 'Projeções Financeiras', subtitle: 'Visualize o futuro do seu negócio', help: 'As projeções são calculadas com base nos últimos 6 meses de vendas.' },
      
      purchases: { title: 'Compras e Fornecedores', subtitle: 'Gerencie suas ordens de compra', help: 'Cadastre fornecedores, crie ordens de compra e acompanhe entregas.', helpLong: 'Cadastre fornecedores, crie ordens e acompanhe entregas. O estoque atualiza automaticamente.' },
      
      salesgoals: { title: 'Metas de Vendas', subtitle: 'Defina e monitore seus objetivos' },
      tasks: { title: 'Controle de Tarefas', subtitle: 'Organize seu dia, economize tempo', help: 'Crie tarefas com data e hora, defina lembretes e organize por categorias.' },
      
      toolrelationships: { title: 'Mapa de Relações', subtitle: 'Como as ferramentas se conectam' },
      transport: { title: 'Transporte / Frota', subtitle: 'Gestão de veículos e despesas' },
      contacts: { title: 'Meus Contatos', subtitle: 'Gerencie contatos e clientes' },
      saleshistory: { title: 'Histórico de Vendas', subtitle: 'Reveja suas vendas anteriores' },
      admin: { title: 'Administração', subtitle: 'Painel de controle administrativo' },
      install: { title: 'Instalar App', subtitle: 'Instale o BRIEFCASE no seu dispositivo' },
      
      caja: { title: 'Meu Contador', help: 'Seu contador virtual pessoal. Registre receitas, despesas, serviços e vendas.' },
      
      
      dashboard: { title: 'Dashboard', help: 'Resumo do seu negócio: Vendas, Receitas, Despesas e Lucro.' },
      expenseAnalysis: { title: 'Análise de Despesas', help: 'Veja como suas despesas se distribuem por categoria.' },
      financialTools: { title: 'Ferramentas Financeiras', help: 'Aqui você pode ver o fluxo de caixa, definir metas, comparar períodos e exportar relatórios.' },
      
      
      
      salesGoals: { title: 'Metas de Vendas', help: 'Crie metas semanais, mensais ou anuais para seu negócio.' },
      salesHistory: { title: 'Histórico de Vendas', help: 'Veja todas as vendas realizadas. Filtre por data e envie recibos por WhatsApp.' },
      
      
      
      
      inventory: { title: 'Inventário', help: 'Gerencie seus produtos e serviços. Adicione novos, edite existentes e use o scanner de código de barras.' },
      
      
      
      
    },
    tutorial: {
      skip: 'Pular',
      start: 'Começar!',
      welcome: { title: 'Bem-vindo!', desc: 'Seu sistema ERP completo.' },
      dashboard: { title: 'Painel', desc: 'Resumo de vendas e estatísticas.' },
      pos: { title: 'Ponto de Venda', desc: 'Caixa registradora fácil de usar.' },
      inventory: { title: 'Inventário', desc: 'Produtos e códigos de barras.' },
      realestate: { title: 'Imóveis', desc: 'Clientes, propriedades e E-Sign.' },
      esign: { title: 'E-Sign', desc: 'Assine documentos de qualquer lugar.' },
      contacts: { title: 'Contatos', desc: 'Importe do Excel ou do celular.' },
      finances: { title: 'Finanças', desc: 'Controle de receitas e despesas.' },
      complete: { title: 'Pronto!', desc: 'Sucesso no seu negócio!' },
    },
    auth: {
      login: 'Entrar',
      register: 'Registrar',
      logout: 'Sair',
      email: 'E-mail',
      password: 'Senha',
      businessName: 'Nome da empresa',
      welcomeBack: 'Bem-vindo de volta',
      createAccount: 'Criar conta',
      noAccount: 'Nao tem conta?',
      hasAccount: 'Ja tem conta?',
      forgotPassword: 'Esqueceu sua senha?',
      resetPassword: 'Redefinir senha',
    },
    nav: {
      dashboard: 'Painel',
      posUnified: 'Caixa / POS',
      groupCrm: 'CRM e Clientes',
      groupOps: 'Operação',
      groupMore: 'Mais',
      groupAdmin: 'Administracao',
      pos: 'Ponto de Venda',
      posGroup: 'Ponto de Venda',
      myAccountant: 'Meu Contador',
      cashRegister: 'Caixa Registradora',
      cashIncome: 'Receitas em Dinheiro',
      salesHistory: 'Historico de Vendas',
      cashAudit: 'Conferencia de Caixa',
      inventory: 'Inventario',
      cash: 'Caixa do Dia',
      closing: 'Fechamento de Caixa',
      settings: 'Configuracoes',
      realEstate: 'Imoveis',
      clients: 'Clientes',
      contacts: 'Contatos',
      news: 'Noticias',
      finances: 'Financas',
      financesDashboard: 'Painel Financeiro',
      cashFlow: 'Fluxo de Caixa',
      salesGoals: 'Metas de Vendas',
      expenseAnalysis: 'Analise de Despesas',
      comparative: 'Comparativo',
      profitability: 'Rentabilidade',
      projections: 'Projecoes',
      budget: 'Orcamentos',
      payroll: 'Folha de Pagamento',
      invoices: 'Faturas',
      appointments: 'Compromissos',
      transport: 'Transporte',
      reports: 'Relatorios',
      admin: 'Administracao',
      revenue: 'Receita (Admin)',
      chat: 'Comunicacao',
      bills: 'Pagamentos',
      tasks: 'Tarefas',
      notes: 'Minhas Notas',
      priceIndex: 'Indice de Precos',
      services: 'Serviços',
      purchases: 'Compras',
      companies: 'Empresas',
      toolMap: 'Mapa de Relacoes',
      businessCard: 'Cartao',
      pricing: 'Planos',
      installApp: 'Instalar App',
    },
    dashboard: {
      title: 'Painel',
      subtitle: 'Visao geral do seu negocio',
      todaySales: 'Vendas de Hoje',
      controlCenter: 'Centro de Controle',
      goodMorning: 'Bom dia',
      goodAfternoon: 'Boa tarde',
      goodEvening: 'Boa noite',
      briefySays: 'Briefy diz',
      todayAgenda: 'Agenda de Hoje',
      noEventsToday: 'Sem compromissos ou tarefas para hoje. Agende algo para começar.',
      viewAll: 'Ver tudo',
      chooseIndustry: 'Escolha sua indústria',
      industryHint: 'Adapte seu Centro de Controle com imagens e atalhos do seu tipo de negócio.',
      industrySaved: 'Centro de Controle personalizado',
      vsYesterday: 'vs ontem',
      salesUp: 'Suas vendas sobem',
      salesDown: 'Suas vendas caem',
      thisWeek: 'esta semana',
      briefyDefault: 'Hoje é um ótimo dia para fazer seu negócio crescer.',
      apptLabel: 'Novo Compromisso',
      tutorialBtn: 'Ver tutorial',
      weekTotal: 'Total da semana',
      briefyRole: 'Assistente IA · Online',
      talkToBriefy: 'Falar com Briefy',
      summaryLine: 'Aqui esta o resumo do seu negocio.',
      period_today: 'Hoje',
      period_7d: '7 dias',
      period_30d: '30 dias',
      revenueOverview: 'Resumo de Vendas',
      incomeVsExpenses: 'Receitas vs Despesas',
      recentTransactions: 'Transacoes Recentes',
      pendingInvoices: 'Faturas Pendentes',
      noTransactions: 'Sem transacoes ainda',
      noPendingInvoices: 'Sem faturas pendentes',
      vsPrev: 'vs periodo anterior',
      todayIncome: 'Receita de Hoje',
      todayExpenses: 'Despesas de Hoje',
      netProfit: 'Lucro Liquido',
      salesCount: 'Numero de Vendas',
      lowStock: 'Produtos com Baixo Estoque',
      weeklyStats: 'Estatisticas Semanais',
      sales: 'VENDAS',
      income: 'RECEITA',
      expenses: 'DESPESAS',
      profit: 'LUCRO',
      salesLabel: 'vendas',
      saleSingular: 'venda',
      loadError: 'Alguns dados não puderam ser carregados. Tente novamente.',
      welcome: 'Bem-vindo',
      quickActions: 'Acoes Rapidas',
      recentActivity: 'Atividade Recente',
      monthlyOverview: 'Visao Mensal',
      topProducts: 'Produtos Mais Vendidos',
      pendingTasks: 'Tarefas Pendentes',
    },
    realEstate: {
      title: 'Imoveis',
      subtitle: 'Gerencie propriedades e clientes',
      properties: 'Propriedades',
      clients: 'Clientes',
      coBrokers: 'Co-Corretores',
      tracking: 'Acompanhamento',
      forSale: 'A Venda',
      forRent: 'Para Alugar',
      buyers: 'Compradores',
      tenants: 'Inquilinos',
      sellers: 'Vendedores',
      activeProspects: 'Ativos',
      closed: 'Fechados',
      documents: 'Documentos',
      addProperty: 'Adicionar Propriedade',
      addClient: 'Adicionar Cliente',
      addBroker: 'Adicionar Co-Corretor',
      propertyType: 'Tipo de Propriedade',
      bedrooms: 'Quartos',
      bathrooms: 'Banheiros',
      area: 'Area',
      location: 'Localizacao',
      budget: 'Orcamento',
      activeProspect: 'Prospecto Ativo',
      incompleteDoc: 'Documentacao Incompleta',
      completeDoc: 'Documentacao Completa',
      programBeneficiary: 'Beneficiario do Programa',
      importFromExcel: 'Importar do Excel',
      importFromPhone: 'Importar do Celular',
      howToUse: 'Como usar?',
      interaction: 'Interacao',
      addInteraction: 'Adicionar Interacao',
    },
    contacts: {
      title: 'Contatos',
      subtitle: 'Gerencie sua rede de contatos',
      addContact: 'Adicionar Contato',
      allContacts: 'Todos os Contatos',
      favorites: 'Favoritos',
      recent: 'Recentes',
      company: 'Empresa',
      position: 'Cargo',
      tags: 'Tags',
      searchPlaceholder: 'Buscar por nome, telefone, e-mail ou empresa...',
    },
    finances: {
      title: 'Centro Financeiro',
      subtitle: 'Gerencie suas financas',
      cashFlow: 'Fluxo de Caixa',
      bills: 'Contas a Pagar',
      receivables: 'Contas a Receber',
      budget: 'Orcamentos',
      reports: 'Relatorios Financeiros',
      income: 'Receita',
      expenses: 'Despesas',
      balance: 'Saldo',
      profit: 'Lucro',
      loss: 'Prejuizo',
      revenue: 'Faturamento',
      costs: 'Custos',
      operatingExpenses: 'Despesas Operacionais',
      netIncome: 'Lucro Liquido',
      grossProfit: 'Lucro Bruto',
    },
    documents: {
      title: 'Documentos',
      subtitle: 'Gerencie arquivos e assinaturas',
      upload: 'Enviar Documento',
      sign: 'Assinar',
      download: 'Baixar',
      signed: 'Assinado',
      unsigned: 'Nao Assinado',
      pending: 'Pendente',
      sendForSignature: 'Enviar para Assinatura',
      eSign: 'Assinatura Eletronica',
      downloadSigned: 'Baixar Assinado',
      signatureDate: 'Data da Assinatura',
      signedBy: 'Assinado por',
      placeSignature: 'Coloque sua assinatura',
      drawSignature: 'Desenhe sua Assinatura',
      clearSignature: 'Limpar',
      saveSignature: 'Salvar',
      signatures: 'Assinaturas',
      tapToPlace: 'Toque onde deseja a assinatura',
      dragToMove: 'Arraste para mover',
      size: 'Tamanho',
    },
    pos: {
      title: 'Ponto de Venda',
      searchProduct: 'Buscar produto...',
      cart: 'Carrinho',
      emptyCart: 'Carrinho vazio',
      subtotal: 'Subtotal',
      discount: 'Desconto',
      tax: 'Imposto',
      taxableBase: 'Base tributavel',
      total: 'Total',
      completeSale: 'Finalizar Venda',
      paymentMethod: 'Forma de pagamento',
      cash: 'Dinheiro',
      card: 'Cartao',
      transfer: 'Transferencia',
      saleComplete: 'Venda concluida',
      addToCart: 'Adicionar ao carrinho',
      removeFromCart: 'Remover do carrinho',
      checkout: 'Finalizar',
      receipt: 'Recibo',
    },
    briefySettings: {
      desc: 'Controle como o Briefy te acompanha dentro do BRIEFCASE.',
      interactive: 'Modo Interativo do Briefy',
      interactiveDesc: 'Briefy aparece como um personagem vivo dentro do app',
      idle: 'Interacoes em repouso',
      idleDesc: 'Briefy aparece apos ~1 minuto sem atividade',
      haptics: 'Vibracao tatil',
      hapticsDesc: 'Vibracao suave ao aparecer (somente celular)',
      sound: 'Efeitos sonoros',
      soundDesc: 'Som sutil quando o Briefy aparece',
      animations: 'Animacoes do Briefy',
      animationsDesc: 'Animacoes de entrada, movimento e gestos',
    },
    inventory: {
      title: 'Inventario',
      labelsBtn: 'Etiquetas',
      addProduct: 'Adicionar Produto',
      editProduct: 'Editar Produto',
      productName: 'Nome do produto',
      description: 'Descricao',
      price: 'Preco de venda',
      cost: 'Custo',
      stock: 'Estoque',
      category: 'Categoria',
      isService: 'E um servico',
      sku: 'SKU',
      products: 'Produtos',
      services: 'Servicos',
      lowStock: 'Estoque Baixo',
      outOfStock: 'Sem Estoque',
      inStock: 'Em Estoque',
    },
    payroll: {
      title: 'Folha de Pagamento',
      subtitle: 'Gerencie funcionarios e pagamentos',
      employees: 'Funcionarios',
      addEmployee: 'Adicionar Funcionario',
      salary: 'Salario',
      bonus: 'Bonus',
      deductions: 'Deducoes',
      netPay: 'Pagamento Liquido',
      payPeriod: 'Periodo de Pagamento',
      generatePayroll: 'Gerar Folha de Pagamento',
      earnings: 'Rendimentos',
      taxWithholding: 'Retencao de Impostos', noRecords: 'Sem registros de folha', noAttendance: 'Sem registros de presença este mês', noPaystubs: 'Sem holerites gerados', },
    appointments: {
      title: 'Compromissos',
      subtitle: 'Gerencie seus compromissos com clientes',
      schedule: 'Agendar Compromisso',
      upcoming: 'Proximos',
      past: 'Passados',
      cancelled: 'Cancelados',
      reschedule: 'Reagendar',
      client: 'Cliente',
      dateTime: 'Data e Hora',
      location: 'Local',
      reminder: 'Lembrete',
    },
    news: {
      title: 'Noticias',
      subtitle: 'Mantenha-se informado',
      createPost: 'Criar Publicacao',
      feed: 'Feed',
      myPosts: 'Minhas Publicacoes',
      like: 'Curtir',
      comment: 'Comentar',
      share: 'Compartilhar',
      searchNews: 'Buscar noticias...',
    },
    settings: {
      title: 'Configuracoes',
      currency: 'Moeda',
      language: 'Idioma',
      businessName: 'Nome do Negocio',
      profile: 'Perfil',
      account: 'Conta',
      notifications: 'Notificacoes',
      security: 'Seguranca',
      theme: 'Tema',
      darkMode: 'Modo Escuro',
      lightMode: 'Modo Claro',
      changePassword: 'Alterar Senha',
      twoFactor: 'Autenticacao de Dois Fatores',
    },
    errors: {
      required: 'Este campo e obrigatorio',
      invalidEmail: 'E-mail invalido',
      invalidPhone: 'Telefone invalido',
      minLength: 'Minimo {0} caracteres',
      maxLength: 'Maximo {0} caracteres',
      networkError: 'Erro de conexao',
      serverError: 'Erro do servidor',
      notFound: 'Nao encontrado',
      unauthorized: 'Nao autorizado',
      forbidden: 'Acesso negado',
      loadError: 'Erro ao carregar',
      saveError: 'Erro ao salvar',
      deleteError: 'Erro ao excluir',
    },
    success: {
      saved: 'Salvo com sucesso',
      deleted: 'Excluido com sucesso',
      updated: 'Atualizado com sucesso',
      created: 'Criado com sucesso',
      sent: 'Enviado com sucesso',
      copied: 'Copiado para a area de transferencia',
    },
    tutorial: {
      welcome: 'Bem-vindo ao BRIEFCASE',
      skip: 'Pular',
      next: 'Proximo',
      previous: 'Anterior',
      finish: 'Finalizar',
      step: 'Passo',
    },
    categories: {
      all: 'Todas as Categorias',
      manage: 'Gerenciar Categorias',
    },
    ui: {
      description: 'Descrição',
      category: 'Categoria',
      phone: 'Telefone',
      address: 'Endereço',
      location: 'Localização',
      period: 'Período',
      commission: 'Comissão',
      code: 'Código',
      client: 'Cliente',
      clientName: 'Nome do cliente',
      vehicle: 'Veículo',
      type: 'Tipo',
      newConversation: 'Nova Conversa',
      online: 'Online',
      noMessages: 'Sem mensagens',
      startConversation: 'Inicie a conversa',
      selectConversation: 'Selecione uma conversa',
      noUsersAvailable: 'Sem usuários disponíveis',
      searchUsers: 'Buscar usuários...',
      noConversations: 'Sem conversas',
      noDocuments: 'Sem documentos',
      noVehiclesRegistered: 'Sem veículos registrados',
      noExpensesRegistered: 'Sem despesas registradas',
      noPropertiesRegistered: 'Sem propriedades registradas',
      noClientsRegistered: 'Sem clientes registrados',
      noContactsRegistered: 'Sem contatos registrados',
      noInvoicesRegistered: 'Sem faturas registradas',
      noPaymentsRegistered: 'Sem pagamentos registrados',
      noTasksRegistered: 'Sem tarefas registradas',
      noEmployeesRegistered: 'Sem funcionários registrados',
      noBudgetsRegistered: 'Sem orçamentos registrados',
      noEstimatesRegistered: 'Sem estimativas registradas',
      noPurchasesRegistered: 'Sem compras registradas',
      noAppointmentsRegistered: 'Sem agendamentos',
      noSalesRegistered: 'Sem vendas registradas',
      noProductsRegistered: 'Sem produtos registrados',
      noResults: 'Sem resultados',
      noMovementsToday: 'Sem movimentos para este dia',
      addFirstProperty: '+ Adicionar primeira propriedade',
      addFirstClient: '+ Adicionar primeiro cliente',
      addFirstContact: '+ Adicionar primeiro contato',
      addFirstItem: '+ Adicionar primeiro',
      whatsappNumber: 'Número do WhatsApp',
      avgRating: 'Avaliação Média',
      yearTotal: 'Total Ano',
      monthTotal: 'Total Mês',
      dayTotal: 'Total Dia',
      bonus: 'Bônus',
      medicalInsurance: 'Plano de Saúde',
      employeeInfo: 'INFO DO FUNCIONÁRIO',
      periodInfo: 'INFO DO PERÍODO',
      validUntil: 'Válido até',
      validityDays: 'Dias de validade',
      termsConditions: 'Termos e Condições',
      termsPlaceholder: 'Termos e condições...',
      addItem: 'Adicionar item',
      newBudget: 'Novo Orçamento',
      newEstimate: 'Nova Estimativa',
      selectCategory: 'Selecione uma categoria',
      uncategorized: 'Sem categoria',
      allVehicles: 'Todos os veículos',
      clientType: 'Tipo de Cliente',
      company: 'Empresa',
      active: 'Ativo',
      inactive: 'Inativo',
      pending: 'Pendente',
      completed: 'Completo',
      cancelled: 'Cancelado',
      paid: 'Pago',
      unpaid: 'Não pago',
      total: 'Total',
      subtotal: 'Subtotal',
      tax: 'Imposto',
      discount: 'Desconto',
      quantity: 'Quantidade',
      price: 'Preço',
      stock: 'Estoque',
      sku: 'SKU',
      barcode: 'Código de barras',
      profit: 'Lucro',
      revenue: 'Receita',
      expense: 'Despesa',
      payment: 'Pagamento',
      method: 'Método',
      status: 'Status',
      notes: 'Notas',
      addNotes: 'Adicionar notas...',
      pickDate: 'Selecionar data',
      pickTime: 'Selecionar hora',
      uploadImage: 'Enviar Imagem',
      changeImage: 'Alterar Imagem',
      removeImage: 'Remover Imagem',
      saving: 'Salvando...',
      deleting: 'Excluindo...',
      uploading: 'Enviando...',
      processing: 'Processando...',
      retry: 'Tentar novamente',
      tryAgain: 'Tentar novamente',
      seeAll: 'Ver tudo',
      seeMore: 'Ver mais',
      seeLess: 'Ver menos',
      thisWeek: 'Esta semana',
      thisMonth: 'Este mês',
      thisYear: 'Este ano',
      lastWeek: 'Semana passada',
      lastMonth: 'Mês passado',
      lastYear: 'Ano passado',
      today: 'Hoje',
      yesterday: 'Ontem',
      tomorrow: 'Amanhã',
      confirmDelete: 'Excluir?',
      confirmDeleteDesc: 'Esta ação não pode ser desfeita',
      saved: 'Salvo',
      created: 'Criado',
      updated: 'Atualizado',
      deleted: 'Excluído',
      errorOccurred: 'Ocorreu um erro',
      tryLater: 'Tente mais tarde',
      requiredField: 'Campo obrigatório',
      invalidEmail: 'E-mail inválido',
      invalidPhone: 'Telefone inválido',
      passwordTooShort: 'Senha muito curta',
      passwordsDontMatch: 'As senhas não coincidem',
      activeEmployees: 'Funcionários Ativos',
      generatePayroll: 'Gerar Folha',
      monthPayroll: 'Folha do Mês',
      employees: 'Funcionários',
      payrollPayments: 'Pagamentos de Folha',
      payStubs: 'Holerites',
      attendance: 'Frequência',
      noEmployees: 'Sem funcionários',
      activos: 'Ativos',
      inactivos: 'Inativos',
      todos: 'Todos',
      todosCategoria: 'Todos',
    },
    settings: {
      title: 'Configurações',
      subtitle: 'Personalize sua conta e preferências',
      profilePhoto: 'Foto de Perfil',
      changePhoto: 'Alterar Foto',
      photoFormats: 'JPG, PNG, WEBP ou GIF. Máximo 5MB.',
      businessInfo: 'Informações do Negócio',
      contactInfo: 'Informações de Contato',
      businessAddress: 'Endereço do Negócio',
      businessPhone: 'Telefone do Negócio',
      businessEmail: 'Email do Negócio',
      businessFax: 'Fax do Negócio',
      currency: 'Moeda',
      language: 'Idioma',
      tax: 'Imposto',
      taxName: 'Nome do Imposto',
      taxRate: 'Alíquota',
      taxEnabled: 'Imposto Ativo',
      twoFactor: 'Autenticação de Dois Fatores',
      changePassword: 'Alterar Senha',
      businessName: 'Nome do Negócio',
      taxConfig: 'Configuração de Impostos',
      applyTax: 'Aplicar imposto às vendas',
      selectRegion: 'Selecione sua região',
      taxRatePct: 'Alíquota (%)',
      taxNameLabel: 'Nome do imposto',
      invoicePreview: 'Pré-visualização na fatura:',
      accountInfo: 'Informações da Conta',
      plan: 'Plano',
      planBusiness: 'Empresarial',
      planFree: 'Gratuito',
      subSuccess: 'Assinatura Bem-sucedida!',
      subSuccessDesc: 'Seu plano foi atualizado. Aproveite todos os recursos.',
    },
    publicCard: {
      notFound: 'Cartão não encontrado',
      notFoundDesc: 'O link pode ter expirado ou estar incorreto.',
      saveContact: 'Salvar nos Contatos',
      share: 'Compartilhar',
    },
    contacts: {
      contact: 'Contato',
      addContact: 'Adicionar Contato',
      rentals: 'Aluguéis',
      sales: 'Vendas',
      houseSales: 'Venda de Casas',
      investors: 'Investidores',
      referrals: 'Indicações',
      suppliers: 'Fornecedores',
      others: 'Outros',
    },
    deal: {
      new: 'Novo',
      contacted: 'Contatado',
      negotiating: 'Negociando',
      won: 'Ganho',
      lost: 'Perdido',
    },
    leads: {
      title: 'CRM Leads',
      subtitle: 'Capture, qualifique e converta oportunidades em clientes',
      addLead: 'Novo Lead',
      noLeads: 'Sem leads ainda',
      noLeadsHint: 'Crie seu primeiro lead ou importe do Excel',
      name: 'Nome', email: 'Email', phone: 'Telefone', company: 'Empresa', position: 'Cargo',
      source: 'Origem', estimatedValue: 'Valor estimado', stage: 'Estágio', tags: 'Tags',
      notes: 'Notas', assignedTo: 'Atribuído a', lastContact: 'Último contato', nextAction: 'Próxima ação',
      kanban: 'Quadro', list: 'Lista',
      stages: { prospect: 'Prospect', contacted: 'Contatado', qualified: 'Qualificado', proposal: 'Proposta', negotiation: 'Negociação', won: 'Ganho', lost: 'Perdido' },
      sources: { web: 'Site', referral: 'Indicação', social: 'Redes Sociais', email: 'Email Marketing', cold_call: 'Cold Call', event: 'Evento', ads: 'Anúncios', portal: 'Portal Cliente', other: 'Outro' },
      aiEnrich: 'Enriquecer com IA', aiEnriching: 'Pesquisando com IA...', enrichSuccess: 'Lead enriquecido',
      convertTo: 'Converter para', convertCustomer: 'Cliente POS', convertRealEstate: 'Cliente Imobiliário', convertContact: 'Contato',
      createAppointment: 'Agendar consulta', createTask: 'Criar tarefa', createInvoice: 'Criar fatura', createQuote: 'Criar orçamento',
      addInteraction: 'Adicionar interação', interactions: 'Interações', interactionType: 'Tipo',
      score: 'Pontuação', hotLead: 'Lead Quente', warmLead: 'Lead Morno', coldLead: 'Lead Frio',
      filterByStage: 'Filtrar por estágio', filterBySource: 'Filtrar por origem',
      totalPipeline: 'Pipeline Total', wonValue: 'Valor Ganho', conversionRate: 'Taxa de Conversão',
    },
    payrollTax: {
      country: 'País', taxSystem: 'Sistema Fiscal', taxId: 'ID Fiscal',
      taxIdLabel: { US: 'EIN / SSN', CO: 'NIT', MX: 'RFC', AR: 'CUIT', ES: 'NIF', CL: 'RUT', PE: 'RUC', BR: 'CNPJ', EC: 'RUC', DO: 'RNC', VE: 'RIF' },
      grossSalary: 'Salário Bruto', netSalary: 'Salário Líquido', deductions: 'Deduções',
      employerContrib: 'Contribuição Empregador', employeeContrib: 'Contribuição Empregado',
      breakdown: 'Detalhamento de Impostos', configCountry: 'Configurar país', countryTaxAuthority: 'Autoridade Fiscal',
      authorities: { US: 'IRS', CO: 'DIAN', MX: 'SAT', AR: 'AFIP', ES: 'Agência Tributária', CL: 'SII', PE: 'SUNAT', BR: 'Receita Federal', EC: 'SRI', DO: 'DGII', VE: 'SENIAT' },
    },
    cajaTabs: { sales: 'Vendas', cashFlow: 'Receitas / Despesas', history: 'Histórico', audit: 'Fechamento', inventory: 'Inventário', reports: 'Relatórios' },
    geo: {
      title: 'Geo-busca de Imóveis', subtitle: 'Filtre por cidade, CEP ou desenhe um raio no mapa',
      searchPlaceholder: 'Cidade, CEP, endereço...', myLocation: 'Minha localização',
      allTypes: 'Todos os tipos', forSale: 'Venda', forRent: 'Aluguel', radius: 'Raio',
      openSearch: 'Geo-busca', searching: 'Buscando...', found: 'imóveis encontrados',
      noResults: 'Sem resultados', tryWidening: 'Amplie o raio ou tente outra área.',
      locationDenied: 'Não foi possível obter sua localização.',
    },
    tour: {
      aiTour: 'Tour AI', generating: 'Gerando roteiro com IA...',
      generatingHint: 'Analisando características e criando narração cinemática',
      error: 'Não foi possível gerar o tour', noImages: 'Este imóvel não tem fotos.',
      scriptError: 'Erro ao gerar roteiro.',
    },
    portal: {
      title: 'Portal do Cliente', welcomeMsg: 'Mensagem de boas-vindas personalizada',
      publicLink: 'Link público', sendWhatsapp: 'Enviar via WhatsApp', openClientView: 'Abrir vista cliente',
      pause: 'Pausar', reactivate: 'Reativar', propertiesToShow: 'Imóveis para mostrar',
      activity: 'Atividade do cliente', visits: 'Visitas', propertyViews: 'Vistas Imóv.',
      favorites: 'Favoritos', messages: 'Mensagens', recentActivity: 'Atividade recente',
      noActivity: 'Sem atividade. Compartilhe o link.', saveChanges: 'Salvar alterações',
    },
    briefy: {
      online: 'Assistente IA · Online',
      typing: 'Digitando...',
      placeholder: 'Digite sua pergunta...',
      startHint: 'Pergunte-me como usar qualquer ferramenta',
      newConv: 'Nova conversa',
      error: '⚠ Desculpe, ocorreu um erro. Tente novamente.',
      toggleBadge: 'Assistente IA',
      toggleDesc: 'Seu assistente IA flutuante disponível em todas as ferramentas. Responde perguntas, explica fluxos e te guia passo a passo.',
      tooltipTitle: 'Por que "Briefy"?',
      tooltipBrief: 'briefs executivos instantâneos',
      tooltipFamily: 'eu vivo dentro do BRIEFCASE',
      tooltipBriefly: 'breve, rápido, sem fricção',
      tool: {
        lead: 'Lead',
        customer: 'Cliente',
        contact: 'Contato',
        task: 'Tarefa',
        appointment: 'Compromisso',
        search: 'Busca',
        summary: 'Resumo',
        recent: 'Recentes',
      },
    },
    voice: {
      permBlocked: '🎙️ Chrome bloqueou o acesso ao microfone.\n\nPara habilitá-lo:\n1. Clique no cadeado 🔒 ao lado da URL.\n2. Escolha "Configurações do site" → Microfone → Permitir.\n3. Recarregue a página.',
      permBlockedShort: '🎙️ Chrome bloqueou o acesso ao microfone.\n\nClique no cadeado 🔒 ao lado da URL → Configurações do site → Microfone → Permitir. Depois recarregue.',
      permError: 'Não foi possível acessar o microfone: ',
      noMic: '🎙️ Nenhum microfone detectado. Verifique que está conectado e que o sistema operacional permite o acesso ao Chrome.',
    },
    facturas: {
      thisMonth: 'Este Mês',
      totalMonth: 'Total do Mês',
      yearTotal: 'Total do Ano',
      searchPh: 'Buscar fornecedor...',
      noInvoices: 'Sem faturas',
      noInvoicesFor: 'Você não tem faturas salvas para',
      addInvoice: 'Adicionar Fatura',
    },
    priceIndex: {
      title: 'Indice de Precos — Compare com a concorrencia',
      subtitle: 'Analise seus preços com IA. Seja competitivo. Maximize sua margem.',
      newAnalysis: 'Nova análise',
      newTitle: 'Nova análise de preço',
      analyze: 'Analisar com IA',
      analyzing: 'Analisando...',
      all: 'Todos',
      products: 'Produtos',
      properties: 'Imóveis',
      kindProduct: 'Produto',
      kindProperty: 'Imóvel',
      itemNamePh: 'Ex: iPhone 16 Pro 256GB, Cobertura Manhattan 2QT',
      userPricePh: 'Seu preço atual',
      descPh: 'Descrição opcional (marca, tamanho, localização, características...)',
      manualComp: 'Concorrentes manuais (opcional)',
      addCompetitor: 'Adicionar',
      competitorName: 'Nome do concorrente',
      competitorPrice: 'Preço',
      emptyTitle: 'Sem análises ainda',
      empty: 'Crie sua primeira análise com o botão "Nova análise" ou peça à Briefy.',
      detailEmptyTitle: 'Selecione uma análise',
      detailEmpty: 'Escolha uma análise à esquerda ou crie uma nova para ver o detalhamento completo.',
      indexLabel: 'Seu preço vs média do mercado',
      vs: 'vs',
      aboveMarket: 'Você está ACIMA do mercado. Pode perder vendas.',
      belowMarket: 'Você está ABAIXO do mercado. Pode subir o preço sem perder demanda.',
      alignedMarket: 'Seu preço está alinhado com o mercado.',
      recommendation: 'Recomendação',
      rec: { raise: 'Suba o preço', lower: 'Baixe o preço', hold: 'Mantenha o preço' },
      marketRange: 'Faixa de mercado',
      min: 'Mínimo',
      avg: 'Média',
      max: 'Máximo',
      competitors: 'Concorrentes',
      you: 'Você',
      tipTitle: 'Dica',
      tip: 'Você também pode pedir à Briefy: "meu café Latte a $5 está caro?" ou "analise o preço da minha cobertura a $450,000". A Briefy faz a análise automaticamente.',
      confirmDelete: 'Excluir esta análise?',
      errorAnalyze: 'Não foi possível analisar o preço. Tente novamente.',
      compareBtn: 'Comparar preço',
    },
  
    customers: { noClients: 'Sem clientes', noProspects: 'Sem prospects', tagVip: 'Cliente VIP', tagFreq: 'Cliente Frequente', tagNew: 'Cliente Novo', tagInactive: 'Cliente Inativo', statTotal: 'Total de Clientes', statBirthdays: 'Aniversários Hoje', btnCategories: 'Categorias', btnProspect: 'Prospect', btnImportPhone: 'Celular', searchPh: 'Buscar por nome, telefone ou email...', vipBadge: 'VIP', vipTooltip: 'Gasto acumulado superior a $100.000' },
    purchases: { newSupplier: 'Novo Fornecedor', newOrder: 'Nova Ordem', noOrders: 'Sem ordens de compra', fPending: 'Pendentes', fApproved: 'Aprovadas', fReceived: 'Recebidas', fCancelled: 'Canceladas', statSuppliers: 'Fornecedores', statOrders: 'Pedidos', statSpend: 'Gasto do Mês', tabOrders: 'Ordens de Compra' },
    bills: { noAccounts: 'Sem contas', noDebtors: 'Sem devedores cadastrados' },
    tasks: { statsBtn: 'Estatísticas', noTasks: 'Nenhuma tarefa criada' },
    budget: { noBudgets: 'Sem orçamentos configurados', noEstimates: 'Sem estimativas criadas' },
    onboarding: {
      setupLabel: 'Configuração Guiada', title: 'Vamos configurar seu negócio', step: 'Passo', skip: 'Pular',
      skipAll: 'Pular configuração', skipStep: 'Pular esta etapa', next: 'Próximo', back: 'Voltar',
      industryStepTitle: 'Qual é o tipo do seu negócio?', industryStepSubtitle: 'Isso personaliza seu painel e seus acessos rápidos.',
      industryNext: 'Próximo', productStepTitle: 'Adicione seu primeiro produto ou serviço',
      productStepSubtitle: 'Assim você pode vendê-lo imediatamente no Ponto de Venda.', productName: 'Nome',
      productNamePh: 'Ex: Corte de cabelo, Café, Consulta...', productPrice: 'Preço', productStock: 'Estoque inicial',
      isService: 'É um serviço (sem estoque)', productInvalid: 'Digite um nome e um preço válido',
      productSaved: 'Produto adicionado!', clientStepTitle: 'Adicione seu primeiro cliente',
      clientStepSubtitle: 'Mantenha o controle de quem compra de você.', clientName: 'Nome do cliente',
      clientNamePh: 'Ex: João Silva', clientPhone: 'Telefone', clientEmail: 'Email',
      clientInvalid: 'Digite o nome do cliente', clientSaved: 'Cliente adicionado!', clientLabel: 'Cliente',
      saleStepTitle: 'Registre sua primeira transação', saleStepSubtitle: 'Simule sua primeira venda com os dados que você acabou de criar.',
      saleSummary: 'Resumo da venda', registerSale: 'Registrar venda', saleSaved: 'Primeira venda registrada!',
      saleNote: 'Primeira venda - Configuração guiada', needProduct: 'Você precisa de um produto para registrar uma venda.',
      backToProduct: 'Voltar e adicionar um produto', doneTitle: 'Tudo pronto!',
      doneSubtitle: 'Sua conta já tem seu primeiro produto, cliente e venda. É assim fácil usar o BRIEFCASE.',
      goToDashboard: 'Ir para o Painel', errorGeneric: 'Algo deu errado. Tente novamente.',
    },
  },
  fr: {
    common: {
      save: 'Enregistrer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      edit: 'Modifier',
      add: 'Ajouter',
      search: 'Rechercher',
      loading: 'Chargement...',
      noData: 'Aucune donnee',
      confirm: 'Confirmer',
      back: 'Retour',
      today: 'Aujourd hui',
      total: 'Total',
      actions: 'Actions',
      new: 'Nouveau',
      close: 'Fermer',
      yes: 'Oui',
      no: 'Non',
      all: 'Tous',
      none: 'Aucun',
      select: 'Selectionner',
      download: 'Telecharger',
      upload: 'Envoyer',
      send: 'Envoyer',
      share: 'Partager',
      view: 'Voir',
      manage: 'Gerer',
      filter: 'Filtrer',
      sort: 'Trier',
      export: 'Exporter',
      import: 'Importer',
      print: 'Imprimer',
      copy: 'Copier',
      paste: 'Coller',
      refresh: 'Actualiser',
      details: 'Details',
      status: 'Statut',
      active: 'Actif',
      inactive: 'Inactif',
      pending: 'En attente',
      completed: 'Termine',
      date: 'Date',
      time: 'Heure',
      name: 'Nom',
      email: 'E-mail',
      phone: 'Telephone',
      address: 'Adresse',
      notes: 'Notes',
      description: 'Description',
      amount: 'Montant',
      price: 'Prix',
      quantity: 'Quantite',
      category: 'Categorie',
      type: 'Type',
      from: 'De',
      to: 'A',
      of: 'de',
      or: 'ou',
      and: 'et',
      howToUse: 'Comment utiliser?',
      myBusiness: 'Mon Entreprise',
      noData: 'Aucune donnée',
      noResults: 'Aucun résultat',
      noResultsDesc: 'Aucune donnée à afficher',
      addFirst: 'Ajouter le premier',
      tryAgain: 'Réessayer',
      next: 'Suivant',
      previous: 'Précédent',
      finish: 'Terminer',
      apply: 'Appliquer',
      reset: 'Réinitialiser',
      copy: 'Copier',
      duplicate: 'Dupliquer',
      preview: 'Aperçu',
      generate: 'Générer',
      success: 'Succès!',
      error: 'Erreur',
      warning: 'Avertissement',
      info: 'Info',
      required: 'Requis',
      optional: 'Optionnel',
      selectOption: 'Sélectionner une option',
    },
    banners: {
      appointments: { title: 'Système de Rendez-vous', subtitle: 'Gérez vos rendez-vous avec les clients', noAppointments: 'Aucun rendez-vous', },
      arqueo: { title: 'Comptage de caisse', subtitle: 'Vérifiez l espèce physique dans la caisse', help: "Comptez l'argent physique dans votre caisse pour vérifier qu'il correspond aux ventes du système." },
      
      bills: { title: 'Comptes à payer', subtitle: 'Évitez les frais, payez à temps', help: 'Suivez vos factures à payer et vos débiteurs.' },
      
      budget: { title: 'Budgets & Devis', subtitle: 'Gérez vos finances et devis', help: 'Créez des budgets et des devis professionnels pour vos clients.' },
      
      businesscard: { title: 'Carte de Visite', subtitle: 'Créez et partagez votre carte professionnelle' },
      cajaregistradora: { title: 'Mon Comptable', subtitle: 'Votre bureau financier virtuel' },
      cashflow: { title: 'Flux de trésorerie', subtitle: 'Visualisez vos entrées et sorties d argent', help: "Visualisez les mouvements d'argent : ventes, autres revenus et dépenses." },
      
      cash: { title: 'Caisse du jour', subtitle: 'Contrôle des revenus et dépenses quotidiennes', help: 'Enregistrez vos revenus et dépenses quotidiens. Les ventes POS sont automatiquement incluses.' },
      
      chat: { title: 'Communication', subtitle: 'Chat interne et appels vidéo' },
      closing: { title: 'Clôture de Caisse', subtitle: 'État des résultats et clôture journalière' },
      companies: { title: 'Mes Entreprises', subtitle: 'Gérez plusieurs entreprises depuis un profil', noCompanies: 'Aucune entreprise enregistrée', },
      comparative: { title: 'Comparaison de périodes', subtitle: 'Comparez les performances entre périodes', help: 'Comparez vos revenus, dépenses et solde entre la période actuelle et la précédente.' },
      
      customers: { title: 'Clients et Prospects', subtitle: 'CRM pour gérer clients et opportunités', help: 'Gérez votre base clients, regroupez par catégorie et suivez les prospects.' },
      
      expenseanalysis: { title: 'Analyse des Dépenses', subtitle: 'Comprenez où va votre argent' },
      facturas: { title: 'Archive de Factures', subtitle: 'Conservez et organisez vos factures' },
      financialreports: { title: 'Rapports Financiers', subtitle: 'Analyse de la situation économique', help: 'Analysez la performance de votre entreprise.' },
      
      financialtools: { title: 'Outils Financiers', subtitle: 'Analysez et optimisez vos finances' },
      news: { title: 'Actualités en Direct', subtitle: 'Restez informé du monde des affaires' },
      pos: { title: 'Caisse enregistreuse', subtitle: 'Recherchez des produits, ajoutez au panier et finalisez', help: 'Recherchez des produits, ajoutez-les au panier, appliquez des remises et complétez la vente.' },
      
      payroll: { title: 'Paie', subtitle: 'Gérez les employés et la paie', help: 'Enregistrez les employés, générez les paies périodiques et suivez la présence.' },
      
      pricing: { title: 'Tarifs et Plans', subtitle: 'Choisissez le plan parfait pour votre entreprise' },
      profitability: { title: 'Analyse de rentabilité', subtitle: 'Analysez les bénéfices par produit', help: 'Découvrez quels produits génèrent le plus de profit.' },
      
      projections: { title: 'Projections financières', subtitle: 'Visualisez l avenir de votre entreprise', help: 'Les projections sont calculées sur la base de vos 6 derniers mois de ventes.' },
      
      purchases: { title: 'Achats et Fournisseurs', subtitle: "Gérez vos commandes d'achat", help: 'Enregistrez les fournisseurs, créez les commandes et suivez les livraisons.', helpLong: "Enregistrez les fournisseurs et suivez les livraisons. L'inventaire se met à jour automatiquement." },
      
      salesgoals: { title: 'Objectifs de Vente', subtitle: 'Définissez et suivez vos objectifs' },
      tasks: { title: 'Suivi des tâches', subtitle: 'Organisez votre journée, gagnez du temps', help: 'Créez des tâches avec date et heure, définissez des rappels et organisez par catégorie.' },
      
      toolrelationships: { title: 'Carte des Relations', subtitle: 'Comment les outils se connectent' },
      transport: { title: 'Transport / Flotte', subtitle: 'Gestion des véhicules et dépenses' },
      contacts: { title: 'Mes Contacts', subtitle: 'Gérez vos contacts et clients' },
      saleshistory: { title: 'Historique des Ventes', subtitle: 'Consultez vos ventes passées' },
      admin: { title: 'Administration', subtitle: 'Panneau de contrôle administratif' },
      install: { title: 'Installer l App', subtitle: 'Installez BRIEFCASE sur votre appareil' },
      
      caja: { title: 'Mon comptable', help: 'Votre comptable virtuel personnel. Enregistrez revenus, dépenses, services et ventes.' },
      
      
      dashboard: { title: 'Tableau de bord', help: "Aperçu de votre entreprise : Ventes, Revenus, Dépenses et Profit." },
      expenseAnalysis: { title: 'Analyse des dépenses', help: 'Visualisez la répartition de vos dépenses par catégorie.' },
      financialTools: { title: 'Outils financiers', help: 'Consultez votre flux de trésorerie, fixez des objectifs et exportez des rapports.' },
      
      
      
      salesGoals: { title: 'Objectifs de vente', help: 'Créez des objectifs hebdomadaires, mensuels ou annuels.' },
      salesHistory: { title: 'Historique des ventes', help: 'Consultez toutes les ventes. Filtrez par date et envoyez les reçus par WhatsApp.' },
      
      
      
      
      inventory: { title: 'Inventaire', help: 'Gérez vos produits et services. Ajoutez, modifiez et utilisez le scanner de code-barres.' },
      
      
      
      
    },
    tutorial: {
      skip: 'Passer',
      start: 'Commencer!',
      welcome: { title: 'Bienvenue!', desc: 'Votre système ERP tout-en-un.' },
      dashboard: { title: 'Tableau de bord', desc: 'Résumé des ventes et statistiques.' },
      pos: { title: 'Point de Vente', desc: 'Caisse facile à utiliser.' },
      inventory: { title: 'Inventaire', desc: 'Produits et codes-barres.' },
      realestate: { title: 'Immobilier', desc: 'Clients, propriétés et E-Sign.' },
      esign: { title: 'E-Sign', desc: 'Signez vos documents partout.' },
      contacts: { title: 'Contacts', desc: 'Importez depuis Excel ou téléphone.' },
      finances: { title: 'Finances', desc: 'Contrôle des revenus et dépenses.' },
      complete: { title: 'Prêt!', desc: 'Succès pour votre entreprise!' },
    },
    auth: {
      login: 'Connexion',
      register: 'S inscrire',
      logout: 'Deconnexion',
      email: 'E-mail',
      password: 'Mot de passe',
      businessName: 'Nom de l entreprise',
      welcomeBack: 'Bienvenue',
      createAccount: 'Creer un compte',
      noAccount: 'Pas de compte?',
      hasAccount: 'Deja un compte?',
      forgotPassword: 'Mot de passe oublie?',
      resetPassword: 'Reinitialiser le mot de passe',
    },
    nav: {
      dashboard: 'Tableau de bord',
      posUnified: 'Caisse / POS',
      groupCrm: 'CRM & Clients',
      groupOps: 'Operations',
      groupMore: 'Plus',
      groupAdmin: 'Administration',
      pos: 'Point de Vente',
      posGroup: 'Point de Vente',
      myAccountant: 'Mon Comptable',
      cashRegister: 'Caisse Enregistreuse',
      cashIncome: 'Revenus en Espèces',
      salesHistory: 'Historique des Ventes',
      cashAudit: 'Vérification de Caisse',
      inventory: 'Inventaire',
      cash: 'Caisse du Jour',
      closing: 'Cloture de Caisse',
      settings: 'Parametres',
      realEstate: 'Immobilier',
      clients: 'Clients',
      contacts: 'Contacts',
      news: 'Actualites',
      finances: 'Finances',
      financesDashboard: 'Tableau Financier',
      cashFlow: 'Flux de Trésorerie',
      salesGoals: 'Objectifs de Vente',
      expenseAnalysis: 'Analyse des Dépenses',
      comparative: 'Comparatif',
      profitability: 'Rentabilité',
      projections: 'Projections',
      budget: 'Budgets',
      payroll: 'Paie',
      invoices: 'Factures',
      appointments: 'Rendez-vous',
      transport: 'Transport',
      reports: 'Rapports',
      admin: 'Administration',
      revenue: 'Revenu (Admin)',
      chat: 'Communication',
      bills: 'Paiements',
      tasks: 'Tâches',
      notes: 'Mes Notes',
      priceIndex: 'Indice des Prix',
      services: 'Services',
      purchases: 'Achats',
      companies: 'Entreprises',
      toolMap: 'Carte des Relations',
      businessCard: 'Carte',
      pricing: 'Plans',
      installApp: 'Installer App',
    },
    dashboard: {
      title: 'Tableau de bord',
      subtitle: 'Apercu de votre entreprise',
      todaySales: 'Ventes du Jour',
      controlCenter: 'Centre de Contrôle',
      goodMorning: 'Bonjour',
      goodAfternoon: 'Bon après-midi',
      goodEvening: 'Bonsoir',
      briefySays: 'Briefy dit',
      todayAgenda: "Agenda du Jour",
      noEventsToday: "Aucun rendez-vous ni tâche aujourd'hui. Planifiez quelque chose pour commencer.",
      viewAll: 'Tout voir',
      chooseIndustry: 'Choisissez votre secteur',
      industryHint: 'Adaptez votre Centre de Contrôle avec des images et raccourcis de votre activité.',
      industrySaved: 'Centre de Contrôle personnalisé',
      vsYesterday: 'vs hier',
      salesUp: 'Vos ventes augmentent',
      salesDown: 'Vos ventes baissent',
      thisWeek: 'cette semaine',
      briefyDefault: "Aujourd'hui est un grand jour pour développer votre entreprise.",
      apptLabel: 'Nouveau RDV',
      tutorialBtn: 'Voir le tutoriel',
      weekTotal: 'Total semaine',
      briefyRole: 'Assistant IA · En ligne',
      talkToBriefy: 'Parler à Briefy',
      summaryLine: "Voici le resume de votre entreprise.",
      period_today: "Aujourd'hui",
      period_7d: '7 jours',
      period_30d: '30 jours',
      revenueOverview: 'Apercu des Ventes',
      incomeVsExpenses: 'Revenus vs Depenses',
      recentTransactions: 'Transactions Recentes',
      pendingInvoices: 'Factures en Attente',
      noTransactions: 'Pas encore de transactions',
      noPendingInvoices: 'Aucune facture en attente',
      vsPrev: 'vs periode precedente',
      todayIncome: 'Revenus du Jour',
      todayExpenses: 'Depenses du Jour',
      netProfit: 'Benefice Net',
      salesCount: 'Nombre de Ventes',
      lowStock: 'Produits en Rupture',
      weeklyStats: 'Statistiques Hebdomadaires',
      sales: 'VENTES',
      income: 'REVENUS',
      expenses: 'DEPENSES',
      profit: 'BENEFICE',
      salesLabel: 'ventes',
      saleSingular: 'vente',
      loadError: "Certaines données n'ont pas pu être chargées. Réessayez.",
      welcome: 'Bienvenue',
      quickActions: 'Actions Rapides',
      recentActivity: 'Activite Recente',
      monthlyOverview: 'Apercu Mensuel',
      topProducts: 'Produits Les Plus Vendus',
      pendingTasks: 'Taches en Attente',
    },
    realEstate: {
      title: 'Immobilier',
      subtitle: 'Gerez les proprietes et les clients',
      properties: 'Proprietes',
      clients: 'Clients',
      coBrokers: 'Co-Courtiers',
      tracking: 'Suivi',
      forSale: 'A Vendre',
      forRent: 'A Louer',
      buyers: 'Acheteurs',
      tenants: 'Locataires',
      sellers: 'Vendeurs',
      activeProspects: 'Actifs',
      closed: 'Clos',
      documents: 'Documents',
      addProperty: 'Ajouter Propriete',
      addClient: 'Ajouter Client',
      addBroker: 'Ajouter Co-Courtier',
      propertyType: 'Type de Propriete',
      bedrooms: 'Chambres',
      bathrooms: 'Salles de bain',
      area: 'Surface',
      location: 'Emplacement',
      budget: 'Budget',
      activeProspect: 'Prospect Actif',
      incompleteDoc: 'Documentation Incomplete',
      completeDoc: 'Documentation Complete',
      programBeneficiary: 'Beneficiaire du Programme',
      importFromExcel: 'Importer depuis Excel',
      importFromPhone: 'Importer depuis Telephone',
      howToUse: 'Comment utiliser?',
      interaction: 'Interaction',
      addInteraction: 'Ajouter Interaction',
    },
    contacts: {
      title: 'Contacts',
      subtitle: 'Gerez votre reseau de contacts',
      addContact: 'Ajouter Contact',
      allContacts: 'Tous les Contacts',
      favorites: 'Favoris',
      recent: 'Recents',
      company: 'Entreprise',
      position: 'Poste',
      tags: 'Tags',
      searchPlaceholder: 'Rechercher par nom, telephone, e-mail ou entreprise...',
    },
    finances: {
      title: 'Centre Financier',
      subtitle: 'Gerez vos finances',
      cashFlow: 'Flux de Tresorerie',
      bills: 'Factures a Payer',
      receivables: 'Creances',
      budget: 'Budgets',
      reports: 'Rapports Financiers',
      income: 'Revenus',
      expenses: 'Depenses',
      balance: 'Solde',
      profit: 'Benefice',
      loss: 'Perte',
      revenue: 'Chiffre d affaires',
      costs: 'Couts',
      operatingExpenses: 'Charges d exploitation',
      netIncome: 'Resultat Net',
      grossProfit: 'Marge Brute',
    },
    documents: {
      title: 'Documents',
      subtitle: 'Gerez les fichiers et signatures',
      upload: 'Envoyer Document',
      sign: 'Signer',
      download: 'Telecharger',
      signed: 'Signe',
      unsigned: 'Non Signe',
      pending: 'En Attente',
      sendForSignature: 'Envoyer pour Signature',
      eSign: 'Signature Electronique',
      downloadSigned: 'Telecharger Signe',
      signatureDate: 'Date de Signature',
      signedBy: 'Signe par',
      placeSignature: 'Placez votre signature',
      drawSignature: 'Dessinez Votre Signature',
      clearSignature: 'Effacer',
      saveSignature: 'Enregistrer',
      signatures: 'Signatures',
      tapToPlace: 'Appuyez ou vous voulez la signature',
      dragToMove: 'Faites glisser pour deplacer',
      size: 'Taille',
    },
    pos: {
      title: 'Point de Vente',
      searchProduct: 'Rechercher produit...',
      cart: 'Panier',
      emptyCart: 'Panier vide',
      subtotal: 'Sous-total',
      discount: 'Remise',
      tax: 'Taxe',
      taxableBase: 'Base imposable',
      total: 'Total',
      completeSale: 'Finaliser Vente',
      paymentMethod: 'Mode de paiement',
      cash: 'Especes',
      card: 'Carte',
      transfer: 'Virement',
      saleComplete: 'Vente terminee',
      addToCart: 'Ajouter au panier',
      removeFromCart: 'Retirer du panier',
      checkout: 'Payer',
      receipt: 'Recu',
    },
    briefySettings: {
      desc: 'Controlez comment Briefy vous accompagne dans BRIEFCASE.',
      interactive: 'Mode Interactif de Briefy',
      interactiveDesc: 'Briefy apparait comme un personnage vivant dans l\'application',
      idle: 'Interactions au repos',
      idleDesc: 'Briefy apparait apres ~1 minute d\'inactivite',
      haptics: 'Retour haptique',
      hapticsDesc: 'Vibration douce a l\'apparition (mobile uniquement)',
      sound: 'Effets sonores',
      soundDesc: 'Son subtil a l\'apparition de Briefy',
      animations: 'Animations de Briefy',
      animationsDesc: 'Animations d\'entree, de mouvement et de gestes',
    },
    inventory: {
      title: 'Inventaire',
      labelsBtn: 'Etiquettes',
      addProduct: 'Ajouter Produit',
      editProduct: 'Modifier Produit',
      productName: 'Nom du produit',
      description: 'Description',
      price: 'Prix de vente',
      cost: 'Cout',
      stock: 'Stock',
      category: 'Categorie',
      isService: 'Est un service',
      sku: 'SKU',
      products: 'Produits',
      services: 'Services',
      lowStock: 'Stock Faible',
      outOfStock: 'Rupture de Stock',
      inStock: 'En Stock',
    },
    payroll: {
      title: 'Paie',
      subtitle: 'Gerez les employes et les paiements',
      employees: 'Employes',
      addEmployee: 'Ajouter Employe',
      salary: 'Salaire',
      bonus: 'Prime',
      deductions: 'Deductions',
      netPay: 'Salaire Net',
      payPeriod: 'Periode de Paie',
      generatePayroll: 'Generer Paie',
      earnings: 'Gains',
      taxWithholding: 'Retenue d Impot', noRecords: 'Aucun enregistrement de paie', noAttendance: 'Aucun enregistrement de présence ce mois', noPaystubs: 'Aucun bulletin généré', },
    appointments: {
      title: 'Rendez-vous',
      subtitle: 'Gerez vos rendez-vous avec les clients',
      schedule: 'Planifier Rendez-vous',
      upcoming: 'A Venir',
      past: 'Passes',
      cancelled: 'Annules',
      reschedule: 'Reprogrammer',
      client: 'Client',
      dateTime: 'Date et Heure',
      location: 'Lieu',
      reminder: 'Rappel',
    },
    news: {
      title: 'Actualites',
      subtitle: 'Restez informe',
      createPost: 'Creer Publication',
      feed: 'Fil d actualite',
      myPosts: 'Mes Publications',
      like: 'J aime',
      comment: 'Commenter',
      share: 'Partager',
      searchNews: 'Rechercher actualites...',
    },
    settings: {
      title: 'Parametres',
      currency: 'Devise',
      language: 'Langue',
      businessName: 'Nom de l Entreprise',
      taxConfig: 'Configuration des Taxes',
      applyTax: 'Appliquer la taxe aux ventes',
      selectRegion: 'Sélectionnez votre région',
      taxRatePct: 'Taux de taxe (%)',
      taxNameLabel: 'Nom de la taxe',
      invoicePreview: 'Aperçu de la facture:',
      accountInfo: 'Infos du Compte',
      plan: 'Plan',
      planBusiness: 'Entreprise',
      planFree: 'Gratuit',
      subSuccess: 'Abonnement Réussi!',
      subSuccessDesc: 'Votre plan a été mis à jour. Profitez de toutes les fonctionnalités.',
      profile: 'Profil',
      account: 'Compte',
      notifications: 'Notifications',
      security: 'Securite',
      theme: 'Theme',
      darkMode: 'Mode Sombre',
      lightMode: 'Mode Clair',
      changePassword: 'Changer Mot de Passe',
      twoFactor: 'Authentification a Deux Facteurs',
    },
    errors: {
      required: 'Ce champ est obligatoire',
      invalidEmail: 'E-mail invalide',
      invalidPhone: 'Telephone invalide',
      minLength: 'Minimum {0} caracteres',
      maxLength: 'Maximum {0} caracteres',
      networkError: 'Erreur de connexion',
      serverError: 'Erreur du serveur',
      notFound: 'Non trouve',
      unauthorized: 'Non autorise',
      forbidden: 'Acces refuse',
      loadError: 'Erreur de chargement',
      saveError: 'Erreur de sauvegarde',
      deleteError: 'Erreur de suppression',
    },
    success: {
      saved: 'Enregistre avec succes',
      deleted: 'Supprime avec succes',
      updated: 'Mis a jour avec succes',
      created: 'Cree avec succes',
      sent: 'Envoye avec succes',
      copied: 'Copie dans le presse-papiers',
    },
    tutorial: {
      welcome: 'Bienvenue sur BRIEFCASE',
      skip: 'Passer',
      next: 'Suivant',
      previous: 'Precedent',
      finish: 'Terminer',
      step: 'Etape',
    },
    categories: {
      all: 'Toutes les Categories',
      manage: 'Gerer les Categories',
    },
    ui: {
      description: 'Description',
      category: 'Catégorie',
      phone: 'Téléphone',
      address: 'Adresse',
      location: 'Emplacement',
      period: 'Période',
      commission: 'Commission',
      code: 'Code',
      client: 'Client',
      clientName: 'Nom du client',
      vehicle: 'Véhicule',
      type: 'Type',
      newConversation: 'Nouvelle Conversation',
      online: 'En ligne',
      noMessages: 'Aucun message',
      startConversation: 'Démarrer la conversation',
      selectConversation: 'Sélectionner une conversation',
      noUsersAvailable: 'Aucun utilisateur disponible',
      searchUsers: 'Rechercher des utilisateurs...',
      noConversations: 'Aucune conversation',
      noDocuments: 'Aucun document',
      noVehiclesRegistered: 'Aucun véhicule enregistré',
      noExpensesRegistered: 'Aucune dépense enregistrée',
      noPropertiesRegistered: 'Aucune propriété enregistrée',
      noClientsRegistered: 'Aucun client enregistré',
      noContactsRegistered: 'Aucun contact enregistré',
      noInvoicesRegistered: 'Aucune facture enregistrée',
      noPaymentsRegistered: 'Aucun paiement enregistré',
      noTasksRegistered: 'Aucune tâche enregistrée',
      noEmployeesRegistered: 'Aucun employé enregistré',
      noBudgetsRegistered: 'Aucun budget enregistré',
      noEstimatesRegistered: 'Aucun devis enregistré',
      noPurchasesRegistered: 'Aucun achat enregistré',
      noAppointmentsRegistered: 'Aucun rendez-vous',
      noSalesRegistered: 'Aucune vente enregistrée',
      noProductsRegistered: 'Aucun produit enregistré',
      noResults: 'Aucun résultat',
      noMovementsToday: 'Aucun mouvement pour ce jour',
      addFirstProperty: '+ Ajouter première propriété',
      addFirstClient: '+ Ajouter premier client',
      addFirstContact: '+ Ajouter premier contact',
      addFirstItem: '+ Ajouter premier',
      whatsappNumber: 'Numéro WhatsApp',
      avgRating: 'Note Moyenne',
      yearTotal: 'Total Année',
      monthTotal: 'Total Mois',
      dayTotal: 'Total Jour',
      bonus: 'Bonus',
      medicalInsurance: 'Assurance Maladie',
      employeeInfo: 'INFO EMPLOYÉ',
      periodInfo: 'INFO PÉRIODE',
      validUntil: 'Valide jusqu\'à',
      validityDays: 'Jours de validité',
      termsConditions: 'Termes et Conditions',
      termsPlaceholder: 'Termes et conditions...',
      addItem: 'Ajouter item',
      newBudget: 'Nouveau Budget',
      newEstimate: 'Nouveau Devis',
      selectCategory: 'Sélectionner une catégorie',
      uncategorized: 'Sans catégorie',
      allVehicles: 'Tous les véhicules',
      clientType: 'Type de Client',
      company: 'Entreprise',
      active: 'Actif',
      inactive: 'Inactif',
      pending: 'En attente',
      completed: 'Complété',
      cancelled: 'Annulé',
      paid: 'Payé',
      unpaid: 'Non payé',
      total: 'Total',
      subtotal: 'Sous-total',
      tax: 'Taxe',
      discount: 'Remise',
      quantity: 'Quantité',
      price: 'Prix',
      stock: 'Stock',
      sku: 'SKU',
      barcode: 'Code-barres',
      profit: 'Profit',
      revenue: 'Revenu',
      expense: 'Dépense',
      payment: 'Paiement',
      method: 'Méthode',
      status: 'Statut',
      notes: 'Notes',
      addNotes: 'Ajouter notes...',
      pickDate: 'Choisir date',
      pickTime: 'Choisir heure',
      uploadImage: 'Télécharger Image',
      changeImage: 'Changer Image',
      removeImage: 'Supprimer Image',
      saving: 'Enregistrement...',
      deleting: 'Suppression...',
      uploading: 'Téléchargement...',
      processing: 'Traitement...',
      retry: 'Réessayer',
      tryAgain: 'Réessayer',
      seeAll: 'Voir tout',
      seeMore: 'Voir plus',
      seeLess: 'Voir moins',
      thisWeek: 'Cette semaine',
      thisMonth: 'Ce mois',
      thisYear: 'Cette année',
      lastWeek: 'Semaine dernière',
      lastMonth: 'Mois dernier',
      lastYear: 'Année dernière',
      today: 'Aujourd\'hui',
      yesterday: 'Hier',
      tomorrow: 'Demain',
      confirmDelete: 'Supprimer?',
      confirmDeleteDesc: 'Cette action ne peut être annulée',
      saved: 'Enregistré',
      created: 'Créé',
      updated: 'Mis à jour',
      deleted: 'Supprimé',
      errorOccurred: 'Une erreur est survenue',
      tryLater: 'Réessayer plus tard',
      requiredField: 'Champ requis',
      invalidEmail: 'Email invalide',
      invalidPhone: 'Téléphone invalide',
      passwordTooShort: 'Mot de passe trop court',
      passwordsDontMatch: 'Les mots de passe ne correspondent pas',
      activeEmployees: 'Employés Actifs',
      generatePayroll: 'Générer Paie',
      monthPayroll: 'Paie du Mois',
      employees: 'Employés',
      payrollPayments: 'Paiements de Paie',
      payStubs: 'Bulletins',
      attendance: 'Présence',
      noEmployees: 'Aucun employé',
      activos: 'Actifs',
      inactivos: 'Inactifs',
      todos: 'Tous',
      todosCategoria: 'Tous',
    },
    settings: {
      title: 'Paramètres',
      subtitle: 'Personnalisez votre compte et préférences',
      profilePhoto: 'Photo de Profil',
      changePhoto: 'Changer Photo',
      photoFormats: 'JPG, PNG, WEBP ou GIF. Max 5MB.',
      businessInfo: 'Informations Entreprise',
      contactInfo: 'Coordonnées',
      businessAddress: 'Adresse de l\'Entreprise',
      businessPhone: 'Téléphone Entreprise',
      businessEmail: 'Email Entreprise',
      businessFax: 'Fax Entreprise',
      currency: 'Devise',
      language: 'Langue',
      tax: 'Taxe',
      taxName: 'Nom de la Taxe',
      taxRate: 'Taux de Taxe',
      taxEnabled: 'Taxe Activée',
      twoFactor: 'Authentification à Deux Facteurs',
      changePassword: 'Changer le Mot de Passe',
      businessName: 'Nom de l\'Entreprise',
    },
    publicCard: {
      notFound: 'Carte non trouvée',
      notFoundDesc: 'Le lien a peut-être expiré ou être incorrect.',
      saveContact: 'Enregistrer dans les Contacts',
      share: 'Partager',
    },
    contacts: {
      contact: 'Contact',
      addContact: 'Ajouter Contact',
      rentals: 'Locations',
      sales: 'Ventes',
      houseSales: 'Ventes Maisons',
      investors: 'Investisseurs',
      referrals: 'Référents',
      suppliers: 'Fournisseurs',
      others: 'Autres',
    },
    deal: {
      new: 'Nouveau',
      contacted: 'Contacté',
      negotiating: 'Négociation',
      won: 'Gagné',
      lost: 'Perdu',
    },
    leads: {
      title: 'CRM Leads', subtitle: 'Capturez, qualifiez et convertissez les opportunités',
      addLead: 'Nouveau Lead', noLeads: 'Pas encore de leads', noLeadsHint: 'Créez votre premier lead ou importez depuis Excel',
      name: 'Nom', email: 'Email', phone: 'Téléphone', company: 'Entreprise', position: 'Poste',
      source: 'Source', estimatedValue: 'Valeur estimée', stage: 'Étape', tags: 'Étiquettes',
      notes: 'Notes', assignedTo: 'Assigné à', lastContact: 'Dernier contact', nextAction: 'Prochaine action',
      kanban: 'Tableau', list: 'Liste',
      stages: { prospect: 'Prospect', contacted: 'Contacté', qualified: 'Qualifié', proposal: 'Proposition', negotiation: 'Négociation', won: 'Gagné', lost: 'Perdu' },
      sources: { web: 'Site web', referral: 'Recommandation', social: 'Réseaux sociaux', email: 'Email Marketing', cold_call: 'Cold Call', event: 'Événement', ads: 'Publicités', portal: 'Portail Client', other: 'Autre' },
      aiEnrich: 'Enrichir avec IA', aiEnriching: 'Recherche IA en cours...', enrichSuccess: 'Lead enrichi',
      convertTo: 'Convertir en', convertCustomer: 'Client POS', convertRealEstate: 'Client Immobilier', convertContact: 'Contact',
      createAppointment: 'Programmer RDV', createTask: 'Créer tâche', createInvoice: 'Créer facture', createQuote: 'Créer devis',
      addInteraction: 'Ajouter interaction', interactions: 'Interactions', interactionType: 'Type',
      score: 'Score', hotLead: 'Lead Chaud', warmLead: 'Lead Tiède', coldLead: 'Lead Froid',
      filterByStage: 'Filtrer par étape', filterBySource: 'Filtrer par source',
      totalPipeline: 'Pipeline Total', wonValue: 'Valeur Gagnée', conversionRate: 'Taux de Conversion',
    },
    payrollTax: {
      country: 'Pays', taxSystem: 'Système fiscal', taxId: 'ID fiscal',
      taxIdLabel: { US: 'EIN / SSN', CO: 'NIT', MX: 'RFC', AR: 'CUIT', ES: 'NIF', CL: 'RUT', PE: 'RUC', BR: 'CNPJ', EC: 'RUC', DO: 'RNC', VE: 'RIF' },
      grossSalary: 'Salaire Brut', netSalary: 'Salaire Net', deductions: 'Déductions',
      employerContrib: 'Cotisation Employeur', employeeContrib: 'Cotisation Employé',
      breakdown: 'Détail des taxes', configCountry: 'Configurer pays', countryTaxAuthority: 'Autorité Fiscale',
      authorities: { US: 'IRS', CO: 'DIAN', MX: 'SAT', AR: 'AFIP', ES: 'Agencia Tributaria', CL: 'SII', PE: 'SUNAT', BR: 'Receita Federal', EC: 'SRI', DO: 'DGII', VE: 'SENIAT' },
    },
    cajaTabs: { sales: 'Ventes', cashFlow: 'Revenus / Dépenses', history: 'Historique', audit: 'Clôture', inventory: 'Inventaire', reports: 'Rapports' },
    geo: {
      title: 'Géo-recherche', subtitle: 'Filtrez par ville, code postal ou tracez un rayon sur la carte',
      searchPlaceholder: 'Ville, code postal, adresse...', myLocation: 'Ma position',
      allTypes: 'Tous types', forSale: 'À vendre', forRent: 'À louer', radius: 'Rayon',
      openSearch: 'Géo-recherche', searching: 'Recherche...', found: 'biens trouvés',
      noResults: 'Aucun résultat', tryWidening: 'Élargissez le rayon ou changez de zone.',
      locationDenied: 'Position non disponible.',
    },
    tour: {
      aiTour: 'Tour AI', generating: 'Génération du script IA...',
      generatingHint: 'Analyse des caractéristiques et création de la narration',
      error: 'Tour impossible', noImages: 'Aucune photo pour ce bien.', scriptError: 'Erreur de génération.',
    },
    portal: {
      title: 'Portail Client', welcomeMsg: 'Message de bienvenue personnalisé',
      publicLink: 'Lien public', sendWhatsapp: 'Envoyer par WhatsApp', openClientView: 'Vue client',
      pause: 'Mettre en pause', reactivate: 'Réactiver', propertiesToShow: 'Biens à afficher',
      activity: 'Activité client', visits: 'Visites', propertyViews: 'Vues bien',
      favorites: 'Favoris', messages: 'Messages', recentActivity: 'Activité récente',
      noActivity: 'Aucune activité encore. Partagez le lien.', saveChanges: 'Enregistrer',
    },
    briefy: {
      online: 'Assistant IA · En ligne',
      typing: 'Écriture...',
      placeholder: 'Posez votre question...',
      startHint: 'Demandez-moi comment utiliser n\u0027importe quel outil',
      newConv: 'Nouvelle conversation',
      error: '⚠ Désolé, une erreur est survenue. Réessayez.',
      toggleBadge: 'Assistant IA',
      toggleDesc: 'Votre assistant IA flottant disponible dans tous les outils. Répond aux questions, explique les flux et vous guide pas à pas.',
      tooltipTitle: 'Pourquoi "Briefy" ?',
      tooltipBrief: 'briefs exécutifs instantanés',
      tooltipFamily: "je vis dans le BRIEFCASE",
      tooltipBriefly: 'bref, rapide, sans friction',
      tool: {
        lead: 'Prospect',
        customer: 'Client',
        contact: 'Contact',
        task: 'Tâche',
        appointment: 'Rendez-vous',
        search: 'Recherche',
        summary: 'Résumé',
        recent: 'Récents',
      },
    },
    voice: {
      permBlocked: "🎙️ Chrome a bloqué l'accès au microphone.\n\nPour l'activer :\n1. Cliquez sur le cadenas 🔒 à côté de l'URL.\n2. Choisissez \"Paramètres du site\" → Microphone → Autoriser.\n3. Rechargez la page.",
      permBlockedShort: "🎙️ Chrome a bloqué l'accès au microphone.\n\nCliquez sur le cadenas 🔒 à côté de l'URL → Paramètres du site → Microphone → Autoriser. Puis rechargez.",
      permError: "Impossible d'accéder au microphone : ",
      noMic: "🎙️ Aucun microphone détecté. Vérifiez qu'il est connecté et que le système d'exploitation autorise Chrome.",
    },
    facturas: {
      thisMonth: 'Ce mois',
      totalMonth: 'Total du mois',
      yearTotal: 'Total annuel',
      searchPh: 'Rechercher un fournisseur...',
      noInvoices: 'Aucune facture',
      noInvoicesFor: 'Vous n\'avez aucune facture enregistrée pour',
      addInvoice: 'Ajouter une facture',
    },
    priceIndex: {
      title: 'Indice des Prix — Comparez-vous à la concurrence',
      subtitle: 'Analysez vos prix avec IA. Restez compétitif. Maximisez votre marge.',
      newAnalysis: 'Nouvelle analyse',
      newTitle: 'Nouvelle analyse de prix',
      analyze: 'Analyser avec IA',
      analyzing: 'Analyse en cours...',
      all: 'Tous',
      products: 'Produits',
      properties: 'Biens',
      kindProduct: 'Produit',
      kindProperty: 'Bien immobilier',
      itemNamePh: 'Ex: iPhone 16 Pro 256GB, Penthouse Manhattan 2P',
      userPricePh: 'Votre prix actuel',
      descPh: 'Description optionnelle (marque, taille, emplacement, caractéristiques...)',
      manualComp: 'Concurrents manuels (optionnel)',
      addCompetitor: 'Ajouter',
      competitorName: 'Nom du concurrent',
      competitorPrice: 'Prix',
      emptyTitle: 'Aucune analyse pour le moment',
      empty: 'Créez votre première analyse avec le bouton "Nouvelle analyse" ou demandez à Briefy.',
      detailEmptyTitle: 'Sélectionnez une analyse',
      detailEmpty: 'Choisissez une analyse à gauche ou créez-en une nouvelle pour voir le détail complet.',
      indexLabel: 'Votre prix vs moyenne du marché',
      vs: 'vs',
      aboveMarket: 'Vous êtes AU-DESSUS du marché. Vous risquez de perdre des ventes.',
      belowMarket: 'Vous êtes EN DESSOUS du marché. Vous pouvez augmenter sans perdre de demande.',
      alignedMarket: 'Votre prix est aligné avec le marché.',
      recommendation: 'Recommandation',
      rec: { raise: 'Augmentez le prix', lower: 'Baissez le prix', hold: 'Maintenez le prix' },
      marketRange: 'Fourchette du marché',
      min: 'Min',
      avg: 'Moyenne',
      max: 'Max',
      competitors: 'Concurrents',
      you: 'Vous',
      tipTitle: 'Astuce',
      tip: 'Vous pouvez aussi demander à Briefy : "mon café Latte à 5 $ est trop cher ?" ou "analyse le prix de mon penthouse à 450 000 $". Briefy fait l\'analyse automatiquement.',
      confirmDelete: 'Supprimer cette analyse ?',
      errorAnalyze: "Impossible d'analyser le prix. Réessayez.",
      compareBtn: 'Comparer le prix',
    },
  
    customers: { noClients: 'Aucun client', noProspects: 'Aucun prospect', tagVip: 'Client VIP', tagFreq: 'Client fréquent', tagNew: 'Nouveau client', tagInactive: 'Client inactif', statTotal: 'Total clients', statBirthdays: 'Anniversaires aujourd\'hui', btnCategories: 'Catégories', btnProspect: 'Prospect', btnImportPhone: 'Téléphone', searchPh: 'Rechercher par nom, téléphone ou email...', vipBadge: 'VIP', vipTooltip: 'Dépenses cumulées supérieures à 100 000 $' },
    purchases: { newSupplier: 'Nouveau Fournisseur', newOrder: 'Nouvelle Commande', noOrders: 'Aucune commande d\'achat', fPending: 'En attente', fApproved: 'Approuvées', fReceived: 'Reçues', fCancelled: 'Annulées', statSuppliers: 'Fournisseurs', statOrders: 'Commandes', statSpend: 'Dépense du mois', tabOrders: 'Commandes d\'achat' },
    bills: { noAccounts: 'Aucun compte', noDebtors: 'Aucun débiteur enregistré' },
    tasks: { statsBtn: 'Statistiques', noTasks: 'Aucune tâche créée' },
    budget: { noBudgets: 'Aucun budget configuré', noEstimates: 'Aucun devis créé' },
    onboarding: {
      setupLabel: 'Configuration Guidée', title: 'Configurons votre entreprise', step: 'Étape', skip: 'Passer',
      skipAll: 'Passer la configuration', skipStep: 'Passer cette étape', next: 'Suivant', back: 'Retour',
      industryStepTitle: 'Quel est votre type d\'entreprise ?', industryStepSubtitle: 'Cela personnalise votre tableau de bord et vos accès rapides.',
      industryNext: 'Suivant', productStepTitle: 'Ajoutez votre premier produit ou service',
      productStepSubtitle: 'Vous pourrez ainsi le vendre immédiatement au Point de Vente.', productName: 'Nom',
      productNamePh: 'Ex : Coupe de cheveux, Café, Consultation...', productPrice: 'Prix', productStock: 'Stock initial',
      isService: 'Il s\'agit d\'un service (sans stock)', productInvalid: 'Entrez un nom et un prix valide',
      productSaved: 'Produit ajouté !', clientStepTitle: 'Ajoutez votre premier client',
      clientStepSubtitle: 'Suivez qui achète chez vous.', clientName: 'Nom du client',
      clientNamePh: 'Ex : Jean Dupont', clientPhone: 'Téléphone', clientEmail: 'Email',
      clientInvalid: 'Entrez le nom du client', clientSaved: 'Client ajouté !', clientLabel: 'Client',
      saleStepTitle: 'Enregistrez votre première transaction', saleStepSubtitle: 'Simulez votre première vente avec les données que vous venez de créer.',
      saleSummary: 'Résumé de la vente', registerSale: 'Enregistrer la vente', saleSaved: 'Première vente enregistrée !',
      saleNote: 'Première vente - Configuration guidée', needProduct: 'Vous avez besoin d\'un produit pour enregistrer une vente.',
      backToProduct: 'Revenir ajouter un produit', doneTitle: 'Tout est prêt !',
      doneSubtitle: 'Votre compte a déjà votre premier produit, client et vente. Voilà comme BRIEFCASE est facile à utiliser.',
      goToDashboard: 'Aller au Tableau de bord', errorGeneric: 'Une erreur est survenue. Réessayez.',
    },
  },
};



// Currency options
export const currencies = [
  { code: 'USD', name: 'Dolar Estadounidense', symbol: '$', locale: 'en-US' },
  { code: 'EUR', name: 'Euro', symbol: '€', locale: 'de-DE' },
  { code: 'MXN', name: 'Peso Mexicano', symbol: '$', locale: 'es-MX' },
  { code: 'COP', name: 'Peso Colombiano', symbol: '$', locale: 'es-CO' },
  { code: 'ARS', name: 'Peso Argentino', symbol: '$', locale: 'es-AR' },
  { code: 'CLP', name: 'Peso Chileno', symbol: '$', locale: 'es-CL' },
  { code: 'PEN', name: 'Sol Peruano', symbol: 'S/', locale: 'es-PE' },
  { code: 'BRL', name: 'Real Brasileno', symbol: 'R$', locale: 'pt-BR' },
  { code: 'GBP', name: 'Libra Esterlina', symbol: '£', locale: 'en-GB' },
  { code: 'CAD', name: 'Dolar Canadiense', symbol: 'CA$', locale: 'en-CA' },
  { code: 'DOP', name: 'Peso Dominicano', symbol: 'RD$', locale: 'es-DO' },
  { code: 'GTQ', name: 'Quetzal Guatemalteco', symbol: 'Q', locale: 'es-GT' },
  { code: 'HNL', name: 'Lempira Hondureno', symbol: 'L', locale: 'es-HN' },
  { code: 'NIO', name: 'Cordoba Nicaraguense', symbol: 'C$', locale: 'es-NI' },
  { code: 'PAB', name: 'Balboa Panameno', symbol: 'B/.', locale: 'es-PA' },
  { code: 'PYG', name: 'Guarani Paraguayo', symbol: '₲', locale: 'es-PY' },
  { code: 'UYU', name: 'Peso Uruguayo', symbol: '$U', locale: 'es-UY' },
  { code: 'VES', name: 'Bolivar Venezolano', symbol: 'Bs.', locale: 'es-VE' },
  { code: 'CRC', name: 'Colon Costarricense', symbol: '₡', locale: 'es-CR' },
  { code: 'BOB', name: 'Boliviano', symbol: 'Bs.', locale: 'es-BO' },
];

// Language options
export const languages = [
  { code: 'es', name: 'Espanol', flag: '🇪🇸' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'pt', name: 'Portugues', flag: '🇧🇷' },
  { code: 'fr', name: 'Francais', flag: '🇫🇷' },
];

// Property management workspace names
Object.assign(translations.es,{pm:{workspaceTitle:'Propiedades y Gestión',workspaceSubtitle:'Anuncios, clientes y alquileres para agentes, administradores y propietarios.'}});
Object.assign(translations.en,{pm:{workspaceTitle:'Properties & Management',workspaceSubtitle:'Listings, clients and rentals for agents, managers and property owners.'}});
Object.assign(translations.pt,{pm:{workspaceTitle:'Imóveis e Gestão',workspaceSubtitle:'Anúncios, clientes e aluguéis para agentes, administradores e proprietários.'}});
Object.assign(translations.fr,{pm:{workspaceTitle:'Biens et Gestion',workspaceSubtitle:'Annonces, clients et locations pour agents, gestionnaires et propriétaires.'}});

// Merge shared workspace copy without replacing existing namespace entries.
for (const [locale, groups] of Object.entries(workspaceTranslations)) {
  for (const [group, values] of Object.entries(groups)) {
    translations[locale][group] = { ...translations[locale][group], ...values };
  }
}

// Add missing leaf translations while preserving existing locale namespaces.
for (const [locale, entries] of Object.entries(applicationTranslations)) {
  for (const [key, text] of Object.entries(entries)) {
    const parts = key.split('.');
    let node = translations[locale];
    for (const part of parts.slice(0, -1)) {
      if (!node[part] || typeof node[part] !== 'object') node[part] = {};
      node = node[part];
    }
    const leaf = parts[parts.length - 1];
    if (typeof node[leaf] !== 'string') node[leaf] = text;
  }
}

// Reuse complete, existing translations for formerly unregistered UI keys.
for(const [locale,entries] of Object.entries(reviewedFallbackTranslations)){
 for(const [key,value] of Object.entries(entries)){
  const parts=key.split('.');let node=translations[locale];let safe=true;
  for(const part of parts.slice(0,-1)){if(node[part]!==undefined&&typeof node[part]!=='object'){safe=false;break;}if(!node[part])node[part]={};node=node[part];}
  if(safe&&node[parts[parts.length-1]]===undefined)node[parts[parts.length-1]]=value;
 }
}

// Reviewed operational interface strings, including exported report headings.
const operationalKeys={
  "es": {
    "clock.kioskBadge": "Reloj Checador",
    "clock.kioskTitle": "Tu URL de Kiosko",
    "clock.kioskDesc": "Abre este link en cualquier tablet o teléfono en la entrada. Tus empleados marcan con su PIN de 4 dígitos.",
    "clock.copied": "¡Copiado!",
    "clock.copy": "Copiar",
    "clock.open": "Abrir",
    "clock.totalActive": "Empleados activos",
    "clock.inside": "Adentro ahora",
    "clock.eventsToday": "Marcajes hoy",
    "clock.hoursWeek": "Horas 7d",
    "clock.insideNow": "Adentro ahora",
    "clock.noOneInside": "Nadie ha marcado entrada hoy.",
    "clock.since": "desde",
    "clock.markOut": "Salida",
    "clock.notInside": "Fuera / sin marcar",
    "clock.allInside": "¡Todos están adentro!",
    "clock.noPin": "sin PIN",
    "clock.markIn": "Entrada",
    "clock.weeklySummary": "Horas últimos 7 días",
    "clock.noHours": "Sin horas registradas aún.",
    "clock.tEmployee": "Empleado",
    "clock.tHours": "Horas",
    "clock.tOvertime": "Extra",
    "clock.tDays": "Días",
    "clock.openReport": "Reporte de productividad",
    "clock.qrTitle": "Escanea para abrir el Kiosko",
    "clock.qrDesc": "Apunta la cámara del tablet/celular de la entrada.",
    "employeeTasks.errCreate": "No se pudo crear la tarea",
    "employeeTasks.errUpdate": "No se pudo actualizar",
    "employeeTasks.confirmDelete": "¿Borrar esta tarea?",
    "employeeTasks.errDelete": "No se pudo borrar",
    "employeeTasks.allStatus": "Todos los estados",
    "employeeTasks.status.pending": "Pendiente",
    "employeeTasks.status.in_progress": "En progreso",
    "employeeTasks.status.completed": "Completada",
    "employeeTasks.allEmployees": "Todos los empleados",
    "employeeTasks.newTask": "Asignar tarea",
    "employeeTasks.empty": "Sin tareas",
    "employeeTasks.emptyHint": "Asigna labores a tus empleados con el botón \"Asignar tarea\".",
    "employeeTasks.selectEmployee": "-- Seleccionar empleado --",
    "employeeTasks.titlePh": "Título de la tarea",
    "employeeTasks.descPh": "Descripción (opcional)",
    "employeeTasks.priority.low": "Prioridad baja",
    "employeeTasks.priority.medium": "Prioridad media",
    "employeeTasks.priority.high": "Prioridad alta",
    "employeeTasks.saving": "Guardando...",
    "report.errExcel": "No se pudo exportar Excel",
    "report.errPdf": "No se pudo exportar PDF",
    "report.badge": "Reporte",
    "report.title": "Productividad",
    "report.last7": "Últimos 7 días",
    "report.last14": "Últimos 14 días",
    "report.last30": "Últimos 30 días",
    "report.loading": "Generando reporte...",
    "report.noData": "No hay datos para mostrar",
    "report.totalHours": "Horas totales",
    "report.overtime": "Horas extras",
    "report.tasksDone": "Tareas completadas",
    "report.workedRatio": "Empleados activos",
    "report.hoursPerDay": "Horas trabajadas por día",
    "report.noHoursYet": "Aún no hay horas registradas en este rango.",
    "report.hours": "Horas",
    "report.top": "Top empleados",
    "report.detailTitle": "Desglose por empleado",
    "report.noEmployees": "Sin actividad de empleados.",
    "report.tEmp": "Empleado",
    "report.tHours": "Horas",
    "report.tOvertime": "Extras",
    "report.tDays": "Días",
    "report.tTasks": "Tareas",
    "report.tProd": "Productividad",
    "report.tip": "Exporta este reporte para liquidar nómina o compartir con tu contador."
  },
  "en": {
    "clock.kioskBadge": "Time Clock",
    "clock.kioskTitle": "Your kiosk link",
    "clock.kioskDesc": "Open this link on a tablet or phone at the entrance. Employees clock in using their 4-digit PIN.",
    "clock.copied": "Copied!",
    "clock.copy": "Copy",
    "clock.open": "Open",
    "clock.totalActive": "Active employees",
    "clock.inside": "Currently clocked in",
    "clock.eventsToday": "Today’s clock events",
    "clock.hoursWeek": "Hours · 7 days",
    "clock.insideNow": "Currently clocked in",
    "clock.noOneInside": "Nobody has clocked in today.",
    "clock.since": "since",
    "clock.markOut": "Clock out",
    "clock.notInside": "Out / not clocked in",
    "clock.allInside": "Everyone is clocked in!",
    "clock.noPin": "no PIN",
    "clock.markIn": "Clock in",
    "clock.weeklySummary": "Hours in the last 7 days",
    "clock.noHours": "No hours recorded yet.",
    "clock.tEmployee": "Employee",
    "clock.tHours": "Hours",
    "clock.tOvertime": "Overtime",
    "clock.tDays": "Days",
    "clock.openReport": "Productivity report",
    "clock.qrTitle": "Scan to open the kiosk",
    "clock.qrDesc": "Use the camera on the tablet or phone at the entrance.",
    "employeeTasks.errCreate": "Could not create the task",
    "employeeTasks.errUpdate": "Could not update",
    "employeeTasks.confirmDelete": "Delete this task?",
    "employeeTasks.errDelete": "Could not delete",
    "employeeTasks.allStatus": "All statuses",
    "employeeTasks.status.pending": "Pending",
    "employeeTasks.status.in_progress": "In progress",
    "employeeTasks.status.completed": "Completed",
    "employeeTasks.allEmployees": "All employees",
    "employeeTasks.newTask": "Assign task",
    "employeeTasks.empty": "No tasks",
    "employeeTasks.emptyHint": "Assign work to your employees using the “Assign task” button.",
    "employeeTasks.selectEmployee": "-- Select employee --",
    "employeeTasks.titlePh": "Task title",
    "employeeTasks.descPh": "Description (optional)",
    "employeeTasks.priority.low": "Low priority",
    "employeeTasks.priority.medium": "Medium priority",
    "employeeTasks.priority.high": "High priority",
    "employeeTasks.saving": "Saving…",
    "report.errExcel": "Could not export Excel",
    "report.errPdf": "Could not export PDF",
    "report.badge": "Report",
    "report.title": "Productivity",
    "report.last7": "Last 7 days",
    "report.last14": "Last 14 days",
    "report.last30": "Last 30 days",
    "report.loading": "Generating report…",
    "report.noData": "No data to display",
    "report.totalHours": "Total hours",
    "report.overtime": "Overtime hours",
    "report.tasksDone": "Completed tasks",
    "report.workedRatio": "Active employees",
    "report.hoursPerDay": "Hours worked per day",
    "report.noHoursYet": "No hours have been recorded in this date range.",
    "report.hours": "Hours",
    "report.top": "Top employees",
    "report.detailTitle": "Breakdown by employee",
    "report.noEmployees": "No employee activity.",
    "report.tEmp": "Employee",
    "report.tHours": "Hours",
    "report.tOvertime": "Overtime",
    "report.tDays": "Days",
    "report.tTasks": "Tasks",
    "report.tProd": "Productivity",
    "report.tip": "Export this report to prepare payroll or share it with your accountant."
  },
  "pt": {
    "clock.kioskBadge": "Relógio de ponto",
    "clock.kioskTitle": "Seu link do quiosque",
    "clock.kioskDesc": "Abra este link em um tablet ou telefone na entrada. Os funcionários registram o ponto com seu PIN de 4 dígitos.",
    "clock.copied": "Copiado!",
    "clock.copy": "Copiar",
    "clock.open": "Abrir",
    "clock.totalActive": "Funcionários ativos",
    "clock.inside": "Presentes agora",
    "clock.eventsToday": "Registros de ponto hoje",
    "clock.hoursWeek": "Horas · 7 dias",
    "clock.insideNow": "Presentes agora",
    "clock.noOneInside": "Ninguém registrou entrada hoje.",
    "clock.since": "desde",
    "clock.markOut": "Saída",
    "clock.notInside": "Fora / sem registro",
    "clock.allInside": "Todos registraram entrada!",
    "clock.noPin": "sem PIN",
    "clock.markIn": "Entrada",
    "clock.weeklySummary": "Horas dos últimos 7 dias",
    "clock.noHours": "Ainda não há horas registradas.",
    "clock.tEmployee": "Funcionário",
    "clock.tHours": "Horas",
    "clock.tOvertime": "Horas extras",
    "clock.tDays": "Dias",
    "clock.openReport": "Relatório de produtividade",
    "clock.qrTitle": "Escaneie para abrir o quiosque",
    "clock.qrDesc": "Use a câmera do tablet ou telefone da entrada.",
    "employeeTasks.errCreate": "Não foi possível criar a tarefa",
    "employeeTasks.errUpdate": "Não foi possível atualizar",
    "employeeTasks.confirmDelete": "Excluir esta tarefa?",
    "employeeTasks.errDelete": "Não foi possível excluir",
    "employeeTasks.allStatus": "Todos os estados",
    "employeeTasks.status.pending": "Pendente",
    "employeeTasks.status.in_progress": "Em andamento",
    "employeeTasks.status.completed": "Concluída",
    "employeeTasks.allEmployees": "Todos os funcionários",
    "employeeTasks.newTask": "Atribuir tarefa",
    "employeeTasks.empty": "Sem tarefas",
    "employeeTasks.emptyHint": "Atribua atividades aos funcionários com o botão “Atribuir tarefa”.",
    "employeeTasks.selectEmployee": "-- Selecione um funcionário --",
    "employeeTasks.titlePh": "Título da tarefa",
    "employeeTasks.descPh": "Descrição (opcional)",
    "employeeTasks.priority.low": "Prioridade baixa",
    "employeeTasks.priority.medium": "Prioridade média",
    "employeeTasks.priority.high": "Prioridade alta",
    "employeeTasks.saving": "Salvando…",
    "report.errExcel": "Não foi possível exportar Excel",
    "report.errPdf": "Não foi possível exportar PDF",
    "report.badge": "Relatório",
    "report.title": "Produtividade",
    "report.last7": "Últimos 7 dias",
    "report.last14": "Últimos 14 dias",
    "report.last30": "Últimos 30 dias",
    "report.loading": "Gerando relatório…",
    "report.noData": "Não há dados para mostrar",
    "report.totalHours": "Total de horas",
    "report.overtime": "Horas extras",
    "report.tasksDone": "Tarefas concluídas",
    "report.workedRatio": "Funcionários ativos",
    "report.hoursPerDay": "Horas trabalhadas por dia",
    "report.noHoursYet": "Ainda não há horas registradas neste período.",
    "report.hours": "Horas",
    "report.top": "Destaques da equipe",
    "report.detailTitle": "Detalhamento por funcionário",
    "report.noEmployees": "Nenhuma atividade dos funcionários.",
    "report.tEmp": "Funcionário",
    "report.tHours": "Horas",
    "report.tOvertime": "Horas extras",
    "report.tDays": "Dias",
    "report.tTasks": "Tarefas",
    "report.tProd": "Produtividade",
    "report.tip": "Exporte este relatório para preparar a folha de pagamento ou compartilhar com seu contador."
  },
  "fr": {
    "clock.kioskBadge": "Pointeuse",
    "clock.kioskTitle": "Votre lien de borne",
    "clock.kioskDesc": "Ouvrez ce lien sur une tablette ou un téléphone à l’entrée. Les employés pointent avec leur code PIN à 4 chiffres.",
    "clock.copied": "Copié !",
    "clock.copy": "Copier",
    "clock.open": "Ouvrir",
    "clock.totalActive": "Employés actifs",
    "clock.inside": "Actuellement présents",
    "clock.eventsToday": "Pointages du jour",
    "clock.hoursWeek": "Heures · 7 jours",
    "clock.insideNow": "Actuellement présents",
    "clock.noOneInside": "Personne n’a pointé aujourd’hui.",
    "clock.since": "depuis",
    "clock.markOut": "Sortie",
    "clock.notInside": "Absents / sans pointage",
    "clock.allInside": "Tout le monde est présent !",
    "clock.noPin": "sans PIN",
    "clock.markIn": "Entrée",
    "clock.weeklySummary": "Heures des 7 derniers jours",
    "clock.noHours": "Aucune heure enregistrée pour le moment.",
    "clock.tEmployee": "Employé",
    "clock.tHours": "Heures",
    "clock.tOvertime": "Heures supplémentaires",
    "clock.tDays": "Jours",
    "clock.openReport": "Rapport de productivité",
    "clock.qrTitle": "Scannez pour ouvrir la borne",
    "clock.qrDesc": "Utilisez la caméra de la tablette ou du téléphone à l’entrée.",
    "employeeTasks.errCreate": "Impossible de créer la tâche",
    "employeeTasks.errUpdate": "Impossible de mettre à jour",
    "employeeTasks.confirmDelete": "Supprimer cette tâche ?",
    "employeeTasks.errDelete": "Impossible de supprimer",
    "employeeTasks.allStatus": "Tous les statuts",
    "employeeTasks.status.pending": "En attente",
    "employeeTasks.status.in_progress": "En cours",
    "employeeTasks.status.completed": "Terminée",
    "employeeTasks.allEmployees": "Tous les employés",
    "employeeTasks.newTask": "Attribuer une tâche",
    "employeeTasks.empty": "Aucune tâche",
    "employeeTasks.emptyHint": "Attribuez du travail aux employés avec le bouton « Attribuer une tâche ».",
    "employeeTasks.selectEmployee": "-- Sélectionner un employé --",
    "employeeTasks.titlePh": "Titre de la tâche",
    "employeeTasks.descPh": "Description (facultative)",
    "employeeTasks.priority.low": "Priorité basse",
    "employeeTasks.priority.medium": "Priorité moyenne",
    "employeeTasks.priority.high": "Priorité haute",
    "employeeTasks.saving": "Enregistrement…",
    "report.errExcel": "Impossible d’exporter Excel",
    "report.errPdf": "Impossible d’exporter le PDF",
    "report.badge": "Rapport",
    "report.title": "Productivité",
    "report.last7": "7 derniers jours",
    "report.last14": "14 derniers jours",
    "report.last30": "30 derniers jours",
    "report.loading": "Génération du rapport…",
    "report.noData": "Aucune donnée à afficher",
    "report.totalHours": "Total des heures",
    "report.overtime": "Heures supplémentaires",
    "report.tasksDone": "Tâches terminées",
    "report.workedRatio": "Employés actifs",
    "report.hoursPerDay": "Heures travaillées par jour",
    "report.noHoursYet": "Aucune heure enregistrée sur cette période.",
    "report.hours": "Heures",
    "report.top": "Meilleurs employés",
    "report.detailTitle": "Détail par employé",
    "report.noEmployees": "Aucune activité des employés.",
    "report.tEmp": "Employé",
    "report.tHours": "Heures",
    "report.tOvertime": "Heures supplémentaires",
    "report.tDays": "Jours",
    "report.tTasks": "Tâches",
    "report.tProd": "Productivité",
    "report.tip": "Exportez ce rapport pour préparer la paie ou le partager avec votre comptable."
  }
};
for(const [locale,entries]of Object.entries(operationalKeys)){for(const [key,value]of Object.entries(entries)){const parts=key.split(".");let node=translations[locale];for(const part of parts.slice(0,-1)){if(!node[part]||typeof node[part]!=="object")node[part]={};node=node[part];}node[parts[parts.length-1]]=value;}}

const operationalExtra={"es": {"report.tasks": "tareas", "clock.refresh": "Refrescar"}, "en": {"report.tasks": "tasks", "clock.refresh": "Refresh"}, "pt": {"report.tasks": "tarefas", "clock.refresh": "Atualizar"}, "fr": {"report.tasks": "tâches", "clock.refresh": "Actualiser"}};
for(const [locale,entries]of Object.entries(operationalExtra)){for(const [key,value]of Object.entries(entries)){const [group,name]=key.split(".");translations[locale][group][name]=value;}}
